import React, { useEffect, useRef, useState } from "react";
import { useParams, useHistory, Link } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import RSelect from "react-select";
import makeAnimated from "react-select/animated";
import SaveAsImageWithResolution from "./PreviousRes.js";
import moment from "moment";
import clsx from "clsx";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Resizer from "react-image-file-resizer";
import ListItemText from "@material-ui/core/ListItemText";
import MenuIcon from "@material-ui/icons/Menu";
import { Toolbar, Button, Select, TextField } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import { CanvasObject } from "react-design-editor";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import ChangeHistoryIcon from "@material-ui/icons/ChangeHistory";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import TextFieldsIcon from "@material-ui/icons/TextFields";
import TextFormatIcon from "@material-ui/icons/TextFormat";
import LabelIcon from "@material-ui/icons/Label";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import ImageIcon from "@material-ui/icons/Image";
import ClearAllOutlinedIcon from "@material-ui/icons/ClearAllOutlined";
import SaveIcon from "@material-ui/icons/Save";
import CachedIcon from "@material-ui/icons/Cached";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import Menu from "@material-ui/core/Menu";
import Canvasfd from "./Canvsd";
import TextC from "./TextC";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import Savedesign from "./savedesign";
import Loaddesign from "./loaddesign";
import CanvasV from "./CanvasV";
import {
  FormControl,
  InputLabel,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import PanoramaVerticalIcon from "@material-ui/icons/PanoramaVertical";
import PanoramaHorizontalIcon from "@material-ui/icons/PanoramaHorizontal";
import PostAddRoundedIcon from "@material-ui/icons/PostAddRounded";
import AllOutIcon from "@material-ui/icons/AllOut";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import SetFinalDesign from "./SetFinalDesign";
import PersonIcon from "@material-ui/icons/Person";
import FaceIcon from "@material-ui/icons/Face";
import ModelTop from "./ModelTop";
import RemoveIcon from "@material-ui/icons/Remove";
import CenterFocusStrongIcon from "@material-ui/icons/CenterFocusStrong";
import FormatAlignJustifyIcon from "@material-ui/icons/FormatAlignJustify";
import Barcode1 from "./Barcode";
import EditIcon from "@material-ui/icons/Edit";
import GetAppIcon from "@material-ui/icons/GetApp";
import PrintIcon from "@material-ui/icons/Print";
import HelpIcon from "@material-ui/icons/Help";
import Tutorials from "./Tutorial";
import Search from "./Search.js";
import { FeaturedPlayList } from "@material-ui/icons";
import { DecryptED } from "../DecryptJS/Decrypt";
import { useStyles } from "./BootStrap";
import BootstrapTooltip from "./BootStrap";
var QRCode = require("qrcode");
var JsBarcode = require("jsbarcode");

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

function ContainerMain(props) {
  const animatedComponents = makeAnimated();

  const [LAad, setLadd] = useState();
  const [LongestAdd, setLongestAdd] = useState();

  useEffect(() => {
    if (LAad !== undefined && LAad.length > 0) {
      const longestAddressLength = LAad.reduce((maxLength, address) => {
        return Math.max(maxLength, address.length);
      }, 0);
      setLongestAdd(longestAddressLength);
    }
  }, [LAad]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const theme = useTheme();
  const [imgurl, setImg] = React.useState();
  const refInput = useRef();
  const refimg = useRef();
  const [staff, setStaff] = React.useState(null);
  const [stafflist, setStaffList] = React.useState(null);
  const { sid } = useParams();
  const [open, setOpen] = React.useState(false);
  const [se, setFind] = React.useState("");
  const [openTextC, setOpenTC] = React.useState(false);
  const [falias, setFAlias] = React.useState(false);
  const [openShapes, setOpenSh] = React.useState(false);
  const [openPhotos, setOpenPh] = React.useState(false);
  const [SText, setTOpen] = React.useState(false);
  const [mainModel, setMainModel] = React.useState(false);
  const [Static_Data, setStaticData] = React.useState(null);
  const [Parent_Data, setParentData] = React.useState(null);
  const [divlist, setDivlist] = React.useState(null);
  const [Stafftype, setStafftype] = React.useState(null);
  const [StaffD, setStaffD] = React.useState(null);
  const [isRotate, setRotate] = React.useState(false);
  const [classnm, setClassnm] = React.useState(null);
  const [total, setTotal] = React.useState(0);
  const [staffclick, setStaffClick] = React.useState(0);
  const [color, setColor] = React.useState(null);
  const [K, setK] = React.useState(null);
  const [Sdiv, setDiv] = React.useState(null);
  const [Sclass, setClass] = React.useState(null);
  const [Saved, setSaved] = React.useState(false);
  const [Arrayd, setArray] = React.useState(null);
  const [loadD, setLoadD] = React.useState(false);
  const [CurrDesign, setCurrDesign] = React.useState(null);
  const [Canvastype, setCtype] = React.useState(0);
  const [finald, setFinalD] = React.useState(false);
  const [loaderM, setLoaderM] = React.useState(false);
  const [kl, setKL] = React.useState(0);
  const [openD, setOpenD] = React.useState(true);
  const [editable, setEditable] = React.useState(true);
  const [RandomData, setRandomData] = React.useState(null);
  const [iseditclick, setEditclick] = React.useState(true);
  const [islock, setLock] = React.useState(false);
  const [isback, setBack] = React.useState(false);
  const [progress, setprogress] = React.useState(false);
  const [UserID, setUserid] = React.useState(null);
  const [isloaded, setLoaded] = React.useState(false);
  const history = useHistory();
  const [A4, setA4] = React.useState([]);
  const [isTutorial, setTutorial] = React.useState(false);
  const [isSearch, setSearch] = React.useState(false);
  const [isDefault, setIsDefault] = React.useState(false);
  const [classdivmap, setClassDivMap] = React.useState(null);
  const [idesign, setIdesign] = React.useState("");
  const [schoolName, setSchoolName] = React.useState("");
  const [highResolution, setHighResolution] = React.useState(0);

  console.log(highResolution);
  const [classDiv, setClassDiv] = useState({
    SclassName: [],
    SdivName: [],
    SclassId: [],
    SdivId: [],
  });

  const SaveAsImage = () => {
    console.log(
      refInput.current.handler.saveCanvasImage({
        name: "ID",
        format: "base64",
        quality: 0.8,
      })
    );
  };

  const handleMenuItemClick = (type) => {
    setAnchorEl(null);
    handleSave(type);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSave = (type) => {
    // Call a function to save image based on canvas type
    if (type === "currentDesign") {
      // Save image for Current Design
      SaveAsImage();
    } else if (type === "oldDesign") {
      // Save image for Old Design
      SaveAsImageWithResolution({ type: Canvastype, refInput });
    }
  };

  const configUrl =
    "https://topschool.prisms.in/rest/index.php/user_list.json?";

  const token = "#$laksdfnlknoea#$@$%^&%$";
  const configUrl2 = "https://marcopolo.prisms.in";

  useEffect(() => {

    // get hide feature api
    const getHideFeature = async () => {
      const { data} = await axios.post(
        `${configUrl2}/api/idcard/ID-card-hide-feature`,
        { sid: DecryptED(sid) },
      )
      // console.log(data.IDcards[0].values);
      setHighResolution(data.IDcards[0].values);
    }
    const getClassDetails = async () => {
      try {
        const { data } = await axios.post(
          `${configUrl2}/api/tscommon/getallclass`,
          { sid: DecryptED(sid) },
          { headers: { Authorization: token } }
        );
        setClassDiv((prevState) => ({
          ...prevState,
          SclassName: data,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    getClassDetails();
    getHideFeature();
  }, [
    sid,
    Arrayd
      ? Arrayd.usertype === "Student" || Arrayd.usertype === "Parent"
      : null,
  ]);

  useEffect(() => {
    const getDivDetails = async () => {
      try {
        const { data } = await axios.post(
          `${configUrl2}/api/tscommon/multiple/division`,
          {
            classId: classDiv.SclassId ? classDiv.SclassId : 1,
            sid: DecryptED(sid),
          },
          { headers: { Authorization: token } }
        );
        setClassDiv((prevState) => ({
          ...prevState,
          SDivisionName: data,
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (classDiv.SclassId && classDiv.SclassId.length > 0) {
      getDivDetails(classDiv.SclassId);
    }
  }, [classDiv.SclassId, sid]);

  const fetchStaffData = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: `${configUrl2}/api/idcard/staff/data`,
        data: {
          sid: DecryptED(sid),
          did: idesign,
        },
        headers: { Authorization: token },
      });
      var a = [];
      response.data.StaffData.map((i) => {
        if (i.name !== "") {
          const idata = i;

          if (a.length > 0 ? a[0][i.staff_type] === undefined : true) {
            a.length === 0
              ? a.push({ [i.staff_type]: [idata] })
              : (a[0][i.staff_type] = [idata]);
          } else {
            a[0][i.staff_type].push(idata);
          }
          return null;
        }
      });
      if (a.length > 0) {
        setStafftype(Object.keys(a[0]));
        setStaffD(a[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const setStudentId = () => {
      if (Arrayd != null && Arrayd.usertype === "Student") {
        const fieldArray = Arrayd.field_name_display.split(",");
        const fieldArray2 = Arrayd.fields.split(",");
        fieldArray2.unshift("userid");
        fieldArray.unshift("Student ID");

        Arrayd.field_name_display = fieldArray.join(",");
        Arrayd.fields = fieldArray2.join(",");
      }
    };

    setStudentId();
  }, [Arrayd != null && Arrayd.usertype === "Student"]);

  useEffect(() => {
    if (Arrayd != null && Arrayd.usertype === "staff" && Arrayd.design_id) {
      fetchStaffData();
    }
  }, [Arrayd != null && Arrayd.usertype === "staff" && Arrayd.design_id]);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const handleDrawerOpen = () => {
    setOpenD(true);
  };
  useEffect(() => {
    if (CurrDesign === null || CurrDesign === undefined) setMainModel(true);
  }, []);
  const handleDrawerClose = () => {
    setOpenD(false);
  };
  const OpenDesign = (array) => {};
  useEffect(() => {
    axios
      .post(configUrl, {
        fun_name: "GetClassDiv",
        sid: sid,
      })
      .then((res) => {
        axios
          .post(configUrl, {
            fun_name: "GetStaffID",
            sid: sid,
          })
          .then((res1) => {
            // console.log(res1);
            var a = [];
            res1.data.Staffid.map((i) => {
              if (i.name !== "") {
                const idata = i;

                if (a.length > 0 ? a[0][i.staff_type] === undefined : true) {
                  a.length === 0
                    ? a.push({ [i.staff_type]: [idata] })
                    : (a[0][i.staff_type] = [idata]);
                } else {
                  a[0][i.staff_type].push(idata);
                }
                return null;
              }
            });
            if (a.length > 0) {
              // setStafftype(Object.keys(a[0]));
              // setStaffD(a[0]);
            }

            setDivlist(res.data.div);
            setClassnm(res.data.classnm);
            setKL(0);
          });
      });
    const getSchoolName = async () => {
      const data = {
        fun_name: "getSchoolURL",
        sid,
      };
      await axios({
        method: "POST",
        url: "https://topschool.prisms.in/rest/index.php/user_list.json",
        data,
      }).then((response) => {
        setSchoolName(response.data);
      });
    };
    getSchoolName();
  }, []);

  const handleTotal = () => {
    setTotal(0);
  };

  useEffect(() => {
    if (divlist != null) {
      var a = [];
      divlist.map((i) => {
        if (i.class !== "") {
          const idata = i;

          if (a.length > 0 ? a[0][i.class] === undefined : true) {
            a.length === 0
              ? a.push({ [i.class]: [idata] })
              : (a[0][i.class] = [idata]);
          } else {
            a[0][i.class].push(idata);
          }
          return null;
        }
      });
      if (a.length > 0) {
        setClassDivMap(a[0]);
        // if(Arrayd!=null){
        // setClassMap(Arrayd.class.split(','));
        // setClassdMap(Arrayd.className.split(','))
        // }
        // console.log("key", Object.keys(a[0]));
      }
    }
  }, [divlist, Arrayd]);

  const preview = () => {
    setEditclick(false);
    const divl = [];
    const random = Math.floor(Math.random() * classnm.length);
    // console.log(classnm[random].class_name);
    for (let i = 0; i < divlist.length; i++) {
      // console.log(
      //   divlist[i].div_name.startsWith(classnm[random].class_name + "-")
      // );
      if (divlist[i].div_name.startsWith(classnm[random].class_name + "-")) {
        divl.push(divlist[i].div_name);
      }
    }
    if (divl.length === 0) {
      preview();
    }
    if (divl.length > 0) {
      const random2 = Math.floor(Math.random() * divl.length);
      // setClass(classnm[random].class_name)
      // setDiv(divl[random2].div_name)
      getList(classnm[random].class_name, divl[random2]);
    }
    // console.log(divl);
  };
  useEffect(() => {
    setCurrDesign(sessionStorage.getItem("design-name"));
  }, [iseditclick]);
  useEffect(() => {
    setCurrDesign(sessionStorage.getItem("design-name"));
  }, [editable]);
  const EditDes = () => {
    Clear();
    setUserid(null);
    if (Arrayd != null && Arrayd.design !== " " && Arrayd.design !== "") {
      // var dt = JSON.parse(sessionStorage.getItem('design'));
      refInput.current.handler.importJSON(Arrayd.design);
      setEditable(true);
      setEditclick(true);
    } else {
      window.alert("No design is loaded currently");
    }
  };
  const SaveDesign = () => {
    var dname = Arrayd;
    var tf = window.confirm(
      "You want to update current design \n Current Design Name is : " +
        Arrayd.design_name +
        Arrayd.design_id +
        Arrayd.id
    );
    if (tf) {
      setprogress(true);
      // var y = refInput.current.handler.exportJSON();
      var s = refInput.current.handler.canvas.toJSON([
        "lockScalingY",
        "id",
        "textfield",
      ]).objects;
      var v = { ...Arrayd, design: JSON.stringify(s) };

      setArray(v);

      axios
        .post(configUrl, {
          fun_name: "DesignUpdate",
          sid: sid,
          id: dname.id,
          name: dname.name,
          design: JSON.stringify(s),
          ori: Canvastype,
        })
        .then((res) => {
          window.alert("Successfully Updated the design");
          setprogress(false);
        });
    } else {
      console.log("cancelled");
    }
  };

  useEffect(() => {
    if (Static_Data != null || stafflist != null || Parent_Data != null) {
      setK(0);
      setKL(0);
      Load1(0);
    }
  }, [Static_Data, stafflist, staffclick, Parent_Data]);

  const handleNext = () => {
    if (Arrayd.usertype === "staff") {
      if (K < stafflist.length - 1) {
        Load1(K + 1);
        setK(K + 1);
        Clear();
      } else {
        window.alert("final entry");
      }
    } else if (Arrayd.usertype === "Parent") {
      if (K < Parent_Data.length - 1) {
        Load1(K + 1);
        setK(K + 1);
        Clear();
      } else {
        window.alert("final entry");
      }
    } else if (Arrayd.usertype === "Student") {
      if (K < total - 1) {
        Load1(K + 1);
        setK(K + 1);
        Clear();
      } else {
        window.alert("final entry");
      }
    }
  };
  const handlePrev = () => {
    if (K > 0) {
      Load1(K - 1);
      setK(K - 1);
      Clear();
    } else {
      window.alert("first entry");
    }
  };
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        4000,
        4000,
        "PNG",
        200,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const resizeFile2 = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        600,
        600,
        "PNG",
        200,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });
  const resizedataURL = (datas, wantedWidth, wantedHeight) => {
    return new Promise(async function(resolve, reject) {
      // We create an image to receive the Data URI
      var img = document.createElement("img");

      // When the event "onload" is triggered we can resize the image.
      img.onload = function() {
        // We create a canvas and get its context.
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        var dataURI = canvas.toDataURL();
        setLoaded(true);
        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;
    });
  };

  // for rectangle
  const handleChange = async () => {
    var s = `data:image/png;base64,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
         4IrJPR9MEL6OgsbC6dgu22SYZ4syqBf8Xlku47w/OVL/OO7H8oUcGCaCJVXUnwypbbiGmb19fHqE3z340/YPziwtGVqLeNG3w+NazDAnDz8vLPQ8wSkaBw+Vlpn6eHKapoNpnmk5m
         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`;
    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 300,
      height: 300,
      left: 50,
      top: 70,
      scaleX: 0.3,
      scaleY: 0.3,
      editable: true,
      src: s,
      id: "avatar",
    });

    refInput.current.handler.add(imgobj);
  };
  const roundedID = `data:image/png;base64,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
         4IrJPR9MEL6OgsbC6dgu22SYZ4syqBf8Xlku47w/OVL/OO7H8oUcGCaCJVXUnwypbbiGmb19fHqE3z340/YPziwtGVqLeNG3w+NazDAnDz8vLPQ8wSkaBw+Vlpn6eHKapoNpnmk5m
         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`;

  const clipImage = (ctx) => {
    ctx.arc(0.1, 0.1, 150, 2 * Math.PI, false);
    ctx.clip();
  };

  const handleChangeRounded = async () => {
    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: CanvasObject.width / 2 - 150,
      height: CanvasObject.height / 2 - 150,
      left: 50,
      top: 70,
      scaleX: 0.3,
      scaleY: 0.3,
      editable: true,
      src: roundedID,
      id: "avatar",
      clipTo: clipImage,
    });

    refInput.current.handler.add(imgobj);
  };

  // const clipImageRound2 = (ctximg) => {
  //   ctximg.arc(0.1, 0.1, 150, 2 * Math.PI, false);
  //   ctximg.clip();
  // };

  // const handleChangeRounded = async () => {
  //   fabric_2.fabric.Image.fromURL(roundedID, imgobj => {
  //     const mask = new fabric_2.fabric.Circle({
  //       radius: Math.min(imgobj.width, imgobj.height) / 2,
  //       originX: "center",
  //       originY: "center",
  //       left: 0,
  //       top:  0,
  //     });

  //     imgobj.set({
  //       left:      50,
  //       top:       70,
  //       scaleX:    0.3,
  //       scaleY:    0.3,
  //       clipPath:  mask,
  //       clipPathProperties: { absolutePositioned: false },
  //     });

  //   refInput.current.handler.add(imgobj);
  //   });
  // };
  const handleChangeF = async () => {
    var s = `data:image/jpeg;base64,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
  n8/XtQBmDH3s/ex1/T8aTYvp+p/wAaVduP9nnP5e9LQAUU3+H73b73+e/b1z706gAopuxfT9T/AI06gAopo+83/Af5U6gAooooAKKKKACkx8u3t/X1paKAF2N6n/x3/CkqXePQ/p/jUZJPWk0nur/1/wAABKKKcjL9T6+mfUdv50k/eceiSt/XzATY3qf/AB3/AAo2N6n/AMd/wqTePQ/p/jRvHof0/wAaoCPY3qf/AB3/AAo2N6n/AMd/wqTePQ/p/jRvHof0/wAaAI9jep/8d/wo2N6n/wAd/wAKk3j0P6f40bx6H9P8aAIGXZkgYI6Hr1471NH3/D+tRt82c98dPalBI6UAOl6fg38hTKczK3Tnsen5d/8AP1ptABRRRQAVIqjavt+v+cD+VR1MrLtXt/kdu3rn35qZNpXXTy31QET/AHx9f/ZTQoX5t38WPX0xStJ82Acdf8e/6dT+dNyW+9+XB/wFUndJ91cD7o/Zfvo7jwbrGnLIjTWeuSTND/zzjuIv3Qxn/pj+tfS2B/c/Rf8AGvz1/Z/8XL4Z8bW+n3EqLpviJPsExx/q7z/lwm/pX6Gs0qnHHHrj+uP8+9AHlnxl14eHfh34guo5AtxfW39m2/8A101D9zz9PSvzQHfdjP8AF/8AXr7H/ak15lt/DPh2NtnmTXGq3Ef/AD0jj/0WKL/v/wBvxr45oC2l/Nr7rf5hR
  RRQAUUUUAJsPq/6/wCFLTvn/wBr9abQA3a3/PL+X+FOp3z/AO1+tNoAKKKKACiiigApV6j6j+dJRQAUUUVMpcttL3AKKa/3T+H8xTqpO6T7q4BTdi+n6n/Gnp98/X/2UVI/QfX+hoAj2n++n6/40lFFABRRRQAUUUUAFFNT7o/H+Zp1S5Wly26pXv3+QBRRRVAFFFFTP4X8vzQDX+6fw/mKNi+n6n/GnN/B+P8A7NUi/fb8f5inHZei/IAt5prO4huof3c1vLHdQv8A885LabzYvqc//r5r9WvBOsxeKPCmha40ieZfafA83/XaNBFL1B/jRq/KST5l29uCv5fpz+Y/X7R+B3xBt9L8CQabdy4ex1K9t4xx/qVW3aPsf759PpTA8b/aI1hdU+I15ArbodHtLSwj/wCunlebN+c/+FeH10XjDVG1rxV4i1b77ahqVxNGP+eUfm/uh3/yM/TnaACk4+77dPbpS0UAJx9326e3SloooAbub/nr/L/GnU35P9n9KdQA3c3/AD1/l/jTqb8n+z+lHyf7P6UAOooooAKKb8n+z+lOoAKKKb2/4F/7PQA6ipdg9T+n+FQP90/h/MUAOooooAKTt82Pf0/WlX5sY756+1S7B6n9P8KAI8/3fl9ue35f0pKeyrt+v6/4Y/8ArGmUATbF9P1P+NRN1P1P86npmwep/T/CgCKiP+P/AIF/Shvlzntjp71JH3/D+tACH7i/X/GmU+Xp+DfyFMoAKKKKACplVdq9/wDI79/THtzUNSx/cX6VM/hfy/NANfqPp/U0ynv1H0/qaZTjsvRfkAVs2OsX+nRPBaybYmlM2OB80iJu4/Af/rzWNQpZd3PVi3bv+FMALMzMzfMz8u35Y4/Lt3/IoooAKKKb/B/wH+lADqKbxtzt5/v8enX19/X2p1ADcD+5+i/406iigApuB/c/Rf8AGnUUAFNwP7n6L/jTqKAG4H9z9F/xowP7n6L/AI06igAoopf4H+g/rQAb29D/AOO/40lFFRKTVref6AFFNf7p/D+Yp1Wn7sV5X+9L/IBU++fr/wCyint8qY7d/wBTTE++fr/7KKkfoPr/AENAEeT6n8zSUYT+7/L/AOJooAXe3of/AB3/ABo3t6H/AMd/xpKKAGs2/IByT0HTpz3oVtmATgjqOvXntTqUAnpQAm7dznPbpj/PWinbCuOrD9fxx/Ohiu37p/z1+v41Dk+ay7pffYBtFFFWAU5Wbb0x/T/Pv9KbRUz+F/L80ArMC2Pb8h7/AJ5/yKSmv90/h/MU8AnpTjsvRfkAlFKQR1pKYBRTU+6Px/maN37z7q/l/s0AOoopo6J+H/oJoAN6+v6H/CnUUUANyP7/AOq/4U6iigAooooATn0+6Pl59vr60tFFABRRRQAUu4429qSigBdjep/8d/wpKsVVb70v+expNJ7q/wDX/AAdRRRST95x6JK39fMBU++fr/7KKe3zJnt3/UUxPvn6/wDsoqeqAg2N6n/x3/CjY3qf/Hf8KnooAg2N6n/x3/CjY3qf/Hf8KnooAqsuzJAwR0PXrx3qaPv+H9aY/wB8fX/2U0+Pv+H9aACTt+P9KayfLz36+3/6v51NTH6D6/0NJpPdX/r/AIAEVFFFMApyp8vHbp7/AP6/502pU6H6/wBBSaT3V/6/4ADNjen6j/Gl/wBX94cNj/P5fh71LUcnb8f6U1oku3+SX6AJ97CqOP1J9T/n+gpuxvU/+O/4UJ98/X/2UVPQB//Z`;
    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 300,
      height: 300,
      left: 50,
      top: 70,
      scaleX: 0.3,
      scaleY: 0.3,
      editable: true,
      src: s,
      id: "father",
    });

    refInput.current.handler.add(imgobj);
  };
  const handleChangeM = async () => {
    var s = `data:image/png;base64,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
  2fiXwq+cegm1qFj69M47Z4rkL39h79q2w3ef8FvFb7c5+yf2bf/l9hv7jdnttzmgD5Sor6Eu/2T/2lLLJufgh8SUA6svhXVZE/wC+47d0P4Ma5q6/Z
  /8AjhZZ+1fCX4hQYyTv8Ja5wB1PFkaAPIKK7y5+FvxLsyRdfD/xpbkdfO8Ma1GB+L2SisSfwl4ptc/afDeu2+Ovn6TfRYx1zvgXp39KAOeoqzJZ3cLbZbW4jb+68Mit+IKgj8qi8mb/AJ5Sf98N/hQBHRT/AC5P7j/98t/hSbH/ALrf98n/AAoAbRS4PofyNGD6H8jQAlFGCOoxRQAUUUUAFFFFABRRRQAUUUUAFFFFABRS4Pofyo2t6H8jQAlFO2P/AHG/75P+FPEEzEBYZSTgDEbHOenbvQBFRXTaf4L8Yatt/svwr4i1Hfjb9h0bUbrdnpt8i3fOe2K9I0f9mz4/a+UGkfB74iXofG1o/CmsImDjBLy2iKo5BJYgAHJIHNAHiNKOSPqK+1PDn/BPb9rHxGYyPhhPosEhGLjxBrOh6aqgnGXt31CS+QDnObXtxmvqHwJ/wSP+J2oywT/ED4g+FPDNoSrS2ehQ3/iDUwAQWQvNDpdhE2M4dJ7pcjlMEGgD9bv2RYPs37M3wSh/u/D7QSc+r2wc/wDoVfSKdD9f6CuH+Hfguy+HXgXwn4E065nvbHwnoWnaFa3d0saXFzFp1slus8yxARrJKE3sqDaCSBXcJ0P1/oKAI26n6n+dJUpTJJz1Oen/ANek8v3/AE/+vQBHRUnl+/6f/Xo8v3/T/wCvQBHRUnl+/wCn/wBejy/f9P8A69AEdJgeg/IVL5fv+n/16PL9/wBP/r0AQGONuGjQj0KKf5iojZ2jfetbdvrBEf5rVzy/f9P/AK9Hl+/6f/XoAy5tJ0q4XbPpmnzL/dls7eQfk0ZFY8/gjwZdZ+0+EvDVxnr52haZLn677Vs/jXWeX7/p/wDXo8v3/T/69AHnc/wm+Ft1n7T8N/Alxnr53hLQZc/XfYNn8axp/gN8Ebkkz/CP4buT1/4ozw+vX/c09effrXrvl+/6f/Xo8v3/AE/+vQB4ZN+zV+z9cf634N/Dpvp4U0hf/QbYVmS/so/s3TEmT4LfD05648O2K/okagfhX0N5fv8Ap/8AXo8v3/T/AOvQB8zzfsefswTnMnwR8A57lNFijJ/GNlNUJP2Kf2V5c7vgn4NGevl213F19PKu0x+FfU/l+/6f/Xo8v3/T/wCvQB8lSfsNfsoS/e+C/hkf7k+sxf8AovU0x+HTtVV/2Df2S36/BrQh/uap4kT/ANA1oV9f+X7/AKf/AF6PL9/0/wDr0AfG7/sB/sjP974OaV6/Lr3i1P8A0DX1qI/8E/f2Qz1+Dunfh4k8Zj+XiMV9m+X7/p/9ejy/f9P/AK9AHxh/w76/ZCP/ADR2w/8ACn8bD+XiSgf8E+v2Qhz/AMKdsPx8T+Nj+h8SEV9n+X7/AKf/AF6PL9/0/wDr0AfGY/4J/fshjp8HNN/HxF4yP8/ERqwn7BH7JKYx8G9HOP7+s+KX6eu/XWz7+tfYnl+/6f8A16PL9/0/+vQB8jx/sK/snRHKfBjw4T0+e712X9JdWcf4960If2KP2V4MFPgp4OYg5HnW93P/AOjruQEex4r6o8v3/T/69Hl+/wCn/wBegD5vg/ZF/ZmtgBD8Evh8uO7aDbOePUuGJ/Hr3rbt/wBmf9n21x5Hwb+HS4xjPhbSnxjp9+2bP45r3Xy/f9P/AK9Hl+/6f/XoA8utPgr8HrDH2P4V/Dy2K/daLwb4eRxj/bGn7v1rq7Hwj4U0zH9neGdAsNuNv2PR9PttuOBjybdMY7Y6dq6by/f9P/r0eX7/AKf/AF6AKiWttH/q7eBP9yGNf/QVFTAAdAB9BipfL9/0/wDr0eX7/p/9egCOipPL9/0/+vR5fv8Ap/8AXoAjqVOh+v8AQUnl+/6f/Xp6jaMZzzmgD//Z`;
    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 300,
      height: 300,
      left: 50,
      top: 70,
      scaleX: 0.3,
      scaleY: 0.3,
      editable: true,
      src: s,
      id: "mother",
    });

    refInput.current.handler.add(imgobj);
  };

  const handleChangeG = async () => {
    var s = `data:image/jpeg;base64,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
  n8/XtQBmDH3s/ex1/T8aTYvp+p/wAaVduP9nnP5e9LQAUU3+H73b73+e/b1z706gAopuxfT9T/AI06gAopo+83/Af5U6gAooooAKKKKACkx8u3t/X1paKAF2N6n/x3/CkqXePQ/p/jUZJPWk0nur/1/wAABKKKcjL9T6+mfUdv50k/eceiSt/XzATY3qf/AB3/AAo2N6n/AMd/wqTePQ/p/jRvHof0/wAaoCPY3qf/AB3/AAo2N6n/AMd/wqTePQ/p/jRvHof0/wAaAI9jep/8d/wo2N6n/wAd/wAKk3j0P6f40bx6H9P8aAIGXZkgYI6Hr1471NH3/D+tRt82c98dPalBI6UAOl6fg38hTKczK3Tnsen5d/8AP1ptABRRRQAVIqjavt+v+cD+VR1MrLtXt/kdu3rn35qZNpXXTy31QET/AHx9f/ZTQoX5t38WPX0xStJ82Acdf8e/6dT+dNyW+9+XB/wFUndJ91cD7o/Zfvo7jwbrGnLIjTWeuSTND/zzjuIv3Qxn/pj+tfS2B/c/Rf8AGvz1/Z/8XL4Z8bW+n3EqLpviJPsExx/q7z/lwm/pX6Gs0qnHHHrj+uP8+9AHlnxl14eHfh34guo5AtxfW39m2/8A101D9zz9PSvzQHfdjP8AF/8AXr7H/ak15lt/DPh2NtnmTXGq3Ef/AD0jj/0WKL/v/wBvxr45oC2l/Nr7rf5hR
  RRQAUUUUAJsPq/6/wCFLTvn/wBr9abQA3a3/PL+X+FOp3z/AO1+tNoAKKKKACiiigApV6j6j+dJRQAUUUVMpcttL3AKKa/3T+H8xTqpO6T7q4BTdi+n6n/Gnp98/X/2UVI/QfX+hoAj2n++n6/40lFFABRRRQAUUUUAFFNT7o/H+Zp1S5Wly26pXv3+QBRRRVAFFFFTP4X8vzQDX+6fw/mKNi+n6n/GnN/B+P8A7NUi/fb8f5inHZei/IAt5prO4huof3c1vLHdQv8A885LabzYvqc//r5r9WvBOsxeKPCmha40ieZfafA83/XaNBFL1B/jRq/KST5l29uCv5fpz+Y/X7R+B3xBt9L8CQabdy4ex1K9t4xx/qVW3aPsf759PpTA8b/aI1hdU+I15ArbodHtLSwj/wCunlebN+c/+FeH10XjDVG1rxV4i1b77ahqVxNGP+eUfm/uh3/yM/TnaACk4+77dPbpS0UAJx9326e3SloooAbub/nr/L/GnU35P9n9KdQA3c3/AD1/l/jTqb8n+z+lHyf7P6UAOooooAKKb8n+z+lOoAKKKb2/4F/7PQA6ipdg9T+n+FQP90/h/MUAOooooAKTt82Pf0/WlX5sY756+1S7B6n9P8KAI8/3fl9ue35f0pKeyrt+v6/4Y/8ArGmUATbF9P1P+NRN1P1P86npmwep/T/CgCKiP+P/AIF/Shvlzntjp71JH3/D+tACH7i/X/GmU+Xp+DfyFMoAKKKKACplVdq9/wDI79/THtzUNSx/cX6VM/hfy/NANfqPp/U0ynv1H0/qaZTjsvRfkAVs2OsX+nRPBaybYmlM2OB80iJu4/Af/rzWNQpZd3PVi3bv+FMALMzMzfMz8u35Y4/Lt3/IoooAKKKb/B/wH+lADqKbxtzt5/v8enX19/X2p1ADcD+5+i/406iigApuB/c/Rf8AGnUUAFNwP7n6L/jTqKAG4H9z9F/xowP7n6L/AI06igAoopf4H+g/rQAb29D/AOO/40lFFRKTVref6AFFNf7p/D+Yp1Wn7sV5X+9L/IBU++fr/wCyint8qY7d/wBTTE++fr/7KKkfoPr/AENAEeT6n8zSUYT+7/L/AOJooAXe3of/AB3/ABo3t6H/AMd/xpKKAGs2/IByT0HTpz3oVtmATgjqOvXntTqUAnpQAm7dznPbpj/PWinbCuOrD9fxx/Ohiu37p/z1+v41Dk+ay7pffYBtFFFWAU5Wbb0x/T/Pv9KbRUz+F/L80ArMC2Pb8h7/AJ5/yKSmv90/h/MU8AnpTjsvRfkAlFKQR1pKYBRTU+6Px/maN37z7q/l/s0AOoopo6J+H/oJoAN6+v6H/CnUUUANyP7/AOq/4U6iigAooooATn0+6Pl59vr60tFFABRRRQAUu4429qSigBdjep/8d/wpKsVVb70v+expNJ7q/wDX/AAdRRRST95x6JK39fMBU++fr/7KKe3zJnt3/UUxPvn6/wDsoqeqAg2N6n/x3/CjY3qf/Hf8KnooAg2N6n/x3/CjY3qf/Hf8KnooAqsuzJAwR0PXrx3qaPv+H9aY/wB8fX/2U0+Pv+H9aACTt+P9KayfLz36+3/6v51NTH6D6/0NJpPdX/r/AIAEVFFFMApyp8vHbp7/AP6/502pU6H6/wBBSaT3V/6/4ADNjen6j/Gl/wBX94cNj/P5fh71LUcnb8f6U1oku3+SX6AJ97CqOP1J9T/n+gpuxvU/+O/4UJ98/X/2UVPQB//Z`;
    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 300,
      height: 300,
      left: 50,
      top: 70,
      scaleX: 0.3,
      scaleY: 0.3,
      editable: true,
      src: s,
      id: "guardian",
    });

    refInput.current.handler.add(imgobj);
  };

  //background Image
  const handleChangeBack = async (e) => {
    var ImPr = [];
    var fileupl = [];

    // let FileO=[];
    const filesArr = Array.from(e.target.files);
    var len = filesArr.length;
    for (var i = 0; i < len; i++) {
      var f = filesArr[i];
      // let ext1 = filesArr[i].type.substr(0, filesArr[i].type.lastIndexOf("/"));
      let file2 = await resizeFile(f);
      var arr = file2.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let FileO = new File([u8arr], filesArr[i].name, { type: mime });

      ImPr.push(file2);
      fileupl.push(FileO);
      //    props.file(FileO)
      FileO = null;

      arr = null;
      u8arr = null;
    }
    setImg(ImPr);
    var s = new Image();
    s.src = ImPr;

    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 1200,
      height: 1200,
      left: 50,
      top: 70,
      scaleX: 0.25,
      scaleY: 0.25,
      editable: true,
      src: ImPr[0],
      id: "back",
    });

    // Add border to the image object
    imgobj.set({
      borderColor: "black", // Specify border color
      cornerColor: "black", // Specify corner color
      cornerSize: 10, // Adjust corner size as needed
      transparentCorners: false, // Make corners transparent or not
      borderScaleFactor: 2, // Increase border width
      padding: 10, // Adjust padding as needed
    });

    refInput.current.handler.add(imgobj);
    refInput.current.handler.selectById("back");
    refInput.current.handler.sendToBack();
    // refInput.current.handler.canvas.add(imgobj)
    setBack(true);
  };
  const handleLogo = async (e) => {
    var ImPr = [];
    var fileupl = [];
    var filename11 = [];
    var file = null;
    // let FileO=[];
    const filesArr = Array.from(e.target.files);
    var len = filesArr.length;
    for (var i = 0; i < len; i++) {
      var f = filesArr[i];
      let ext1 = filesArr[i].type.substr(0, filesArr[i].type.lastIndexOf("/"));
      let file2 = await resizeFile2(f);
      var arr = file2.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      let FileO = new File([u8arr], filesArr[i].name, { type: mime });

      ImPr.push(file2);
      fileupl.push(FileO);
      //    props.file(FileO)
      FileO = null;

      arr = null;
      u8arr = null;
    }
    setImg(ImPr);
    var s = new Image();
    s.src = ImPr;

    var imgobj = CanvasObject.image.create({
      // angle: 45,
      width: 500,
      height: 500,
      left: 50,
      top: 70,
      scaleX: 0.25,
      scaleY: 0.25,
      editable: true,
      src: ImPr[0],
      id: "logo",
    });

    refInput.current.handler.add(imgobj);
  };
  const Cir = () => {
    refInput.current.handler.add(
      CanvasObject.circle.create({
        radius: 200,
        fill: "",
        stroke: "red",
        strokeWidth: 3,
        originX: "center",
        originY: "center",
        id: "cir",
      })
    );
  };
  const Line = () => {
    refInput.current.handler.add(
      CanvasObject.line.create({
        points: [50, 50, 200, 50],
        stroke: "red",
        strokeWidth: 3,
        id: "line",
      })
    );
  };
  const Tri = () => {
    refInput.current.handler.add(
      CanvasObject.triangle.create({
        width: 200,
        height: 200,
        left: 50,
        top: 300,
        fill: "",
        padding: 10,
        stroke: "red",
        strokeWidth: 3,
        id: "tri",
      })
    );
  };
  const Rect = () => {
    refInput.current.handler.add(
      CanvasObject.rect.create({
        width: 200,
        height: 200,
        left: 50,
        top: 300,
        fill: "",
        stroke: "red",
        strokeWidth: 3,
        id: "rect",
      })
    );
  };

  const Qrcode = () => {
    QRCode.toDataURL(
      JSON.stringify([{ userid: null, name: null, class: null, div: null }])
    )
      .then((url) => {
        var imgobj = CanvasObject.image.create({
          width: 20,
          height: 20,
          left: 50,
          top: 70,
          editable: true,
          src: url,
          id: "qrcode",
        });

        refInput.current.handler.add(imgobj);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const Textbtn = () => {
    var txt = CanvasObject.textbox.create({
      type: "textbox",
      text: "Label",
      lockScalingY: true,
      left: 200,
      top: 200,
      fontSize: 50,
      fontFamily: "Arial",
      fill: "#000000",
    });
    var p1 = refInput.current.canvas.add(txt);
    // console.log("p", p1);
  };

  const FAlias = (val) => {
    var p = "";
    var lock = true;
    if (val === "Name") {
      p = toupper("!name");
      lock = true;
    } else if (val === "Student ID") {
      p = toupper("!userid");
      lock = true;
    } else if (val === "Class") {
      p = toupper("!class");
      lock = true;
    } else if (val === "Father Name") {
      p = toupper("!father_name");
      lock = true;
    } else if (val === "Mother Name") {
      p = toupper("!mother_name");
      lock = true;
    } else if (val === "Full Name With Mother Name") {
      p = toupper("!name_wt_moname");
      lock = true;
    } else if (val === "Guardian Name") {
      p = toupper("!guardianname");
      lock = true;
    } else if (val === "Guardian Relation") {
      p = toupper("!guardianrelation");
      lock = true;
    } else if (val === "Div") {
      p = toupper("!div");
      lock = true;
    } else if (val === "Blood Group") {
      p = toupper("!bloodgroup");
      lock = true;
    } else if (val === "Adhaar No") {
      p = toupper("!adhaar_no");
      lock = true;
    } 
    
     else if (val === "Emergency Contact Number 1") {
      p = toupper("!emergNo1");
      lock = true;
    } else if (val === "Emergency Contact Number 2") {
      p = toupper("!emergNo2");
      lock = true;
    } else if (val === "Emergency Contact Name 1") {
      p = toupper("!emergName1");
      lock = true;
    } else if (val === "Emergency Contact Name 2") {
      p = toupper("!emergName2");
      lock = true;
    } else if (val === "First Name Last Name") {
      p = toupper("!fname_lname");
      lock = true;
    } else if (val === "Apaar Id") {
      p = toupper("!appar_id");
      lock = true;
    } else if (val === "PEN No") {
      p = toupper("!pen_no");
      lock = true;
    } else if (val === "Birthdate") {
      p = toupper("!dob");
      lock = true;
    } else if (val === "Address") {
      p = toupper("!address");
      lock = false;
    } else if (val === "Mobile No.") {
      p = toupper("!mobile");
      lock = true;
    } else if (val === "Staff Id") {
      p = toupper("!staff_id");
      lock = true;
    } else if (val === "Staff Designation") {
      p = toupper("!staffDesig");
      lock = true;
    } else if (val === "Staff Type") {
      p = toupper("!designation");
      lock = true;
    } else if (val === "Mobile No2.") {
      p = toupper("!mobile2");
      lock = true;
    } else if (val === "Mobile No1.") {
      p = toupper("!mobile");
      lock = true;
    } else if (val === "GR No") {
      p = toupper("!genregid");
    } else if (val === "Roll.No") {
      p = toupper("!roll_no");
    } else if (val === "School House") {
      p = toupper("!house_details");
    } else if (val === "Gender") {
      p = toupper("!gender");
    } else if (val === "Qualification") {
      p = toupper("!qualification");
    } else if (val === "Joining date") {
      p = toupper("!joining_date");
    } else if (val === "Employee ID") {
      p = toupper("!employee_id");
    } else if (val === "Permanent Address") {
      p = toupper("!paddress");
      lock = false;
    }
    const txt = CanvasObject.textbox.create({
      type: "textbox",
      text: p,
      left: 200,
      top: 200,
      lockScalingY: lock,
      // maxWidth:200,
      // minWidth:200,
      // maxHeight:200,
      // minHeight:200,
      fontSize: 52,
      fontFamily: "Arial",
      fill: "#000000",
      textAlign: "left",
    });

    refInput.current.canvas.add(txt);
  };

  const setLoadDesign = () => {
    setLoadD(true);
  };

  const LoadDesign = async (array) => {
    setIdesign(array.design_id);
    axios
      .post(configUrl, {
        fun_name: "GetDefaultIDCard",
        sid: sid,
        usertype: array.usertype,
      })
      .then((res) => {
        if (res.data.default.length !== 0) {
          if (res.data.default[0].design_id === array.design_id) {
            setIsDefault(true);
          } else {
            setIsDefault(false);
          }
        } else {
          setIsDefault(false);
        }
      });
    setUserid(null);
    setArray(array);
    Clear();
    var temp;

    if (array.design === null || array.design === "" || array.design === " ") {
      temp =
        '[{"type":"image","version":"3.6.3","originX":"left","originY":"top","left":-450,"top":-450,"width":900,"height":900,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeDashOffset":0,"strokeLineJoin":"miter","strokeMiterLimit":4,"scaleX":1,"scaleY":1,"angle":0,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"#fff","fillRule":"nonzero","paintFirst":"fill","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","cropX":0,"cropY":0,"id":"workarea","name":"","src":"","filters":[]}]';
    } else {
      temp = array.design;
    }
    var ori = parseInt(array.orientation);
    await setCtype(ori);
    await refInput.current.handler.importJSON(temp, () => {
      refInput.current.canvas.renderAll.bind(refInput.current.canvas);
      setLoadD(false);
      setEditclick(true);
    });

    // setCurrDesign(sessionStorage.getItem('design-name'))
  };
  const toupper = (str) => {
    return str.toUpperCase();
  };

  // const toDataURL = (url, callback) => {
  //   // var s= url.replace("https://files.prisms.in","");
  //   var s = url;
  //   var xhr = new XMLHttpRequest();
  //   xhr.onload = function() {
  //     var reader = new FileReader();

  //     reader.onloadend = function() {
  //       callback(reader.result);
  //     };
  //     reader.readAsDataURL(xhr.response);
  //   };
  //   xhr.open("GET", s);
  //   // xhr.setRequestHeader('Content-type', 'application/octet-stream')
  //   // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
  //   xhr.responseType = "blob";
  //   xhr.send();
  // };

  const toDataURL = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      } else {
        console.error(`Failed to load image: ${xhr.status} ${xhr.statusText}`);
        callback(null); // Call the callback with null in case of error
      }
    };
    xhr.onerror = function() {
      console.error("Request failed.");
      callback(null); // Call the callback with null in case of error
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  async function loadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Handle cross-origin issues
      img.onload = () => resolve(url);
      img.onerror = () => reject(url);
      img.src = url;
    });
  }
  // const sleep = (ms) => {ID card generated
  //   return new Promise((resolve) => setTimeout(resolve, ms));
  // };
  const convertDate = (dateString) => {
    var p = dateString.split(/\D/g);
    return [p[2], p[1], p[0]].join("-");
  };
  const convertStr = (String) => {
    var p = String.replace(/,/g, ", ");

    return p;
  };

  const Load = async (arr) => {
    Clear();
    var dt;
    if (Arrayd != null) {
      dt = JSON.parse(Arrayd.design);
    } else {
      return;
    }
    if (dt === null || dt === undefined) {
    } else {
      if (arr != null && arr !== undefined) {
        setLoaderM(true);
        for (let i = 0; i < dt.length; i++) {
          if (Arrayd != null && Arrayd.usertype === "Student") {
            if (dt[i].text === toupper("!name") || dt[i].text == "!name") {
              setEditable(false);
              dt[i].text = toupper(arr.name);
            }
            if (
              dt[i].text === toupper("!fname_lname") ||
              dt[i].text == "!fname_lname"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.fname_lname);
            }
            if (dt[i].text === toupper("!pen_no") || dt[i].text == "!pen_no") {
              setEditable(false);
              dt[i].text = toupper(arr.pen_no);
            }
            if (
              dt[i].text === toupper("!appar_id") ||
              dt[i].text == "!appar_id"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.appar_id);
            }
            if (
              dt[i].text === toupper("!mothername") ||
              dt[i].text == "!mothername"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.mother_name);
            }
            if (
              dt[i].text === toupper("!fathername") ||
              dt[i].text == "!fathername"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.father_name);
            }
            if (dt[i].id === "avatar") {
              if (arr.avatar !== "" && arr.avatar.includes("https://")) {
                // sessionStorage.removeItem('avatar');

                await toDataURL(arr.avatar, async function(dataUrl) {
                  //  console.log('RESULT:', dataUrl)
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  // let FileO = await dataURLtoFile(fil, Static_Data[K].name + '-Avater.png')
                  // let file2 = await resizeFileC(FileO);
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;
                  var hasavatar = dt.filter((e) => e.id === "father");
                  if (
                    hasavatar.length === 0 ||
                    Static_Data[K].mother_avatar === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  } else if (hasavatar.length > 0) {
                    if (
                      hasavatar[0].src === undefined ||
                      hasavatar[0].src === ""
                    ) {
                      setTimeout(() => {
                        RenderImg(JSON.stringify(dt));
                      }, 200);
                    }
                  }
                  // sessionStorage.setItem('avatar', file2)
                  // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id === "father") {
              if (
                arr.father_avatar.length > 0 &&
                arr.father_avatar.includes("https://")
              ) {
                await toDataURL(arr.father_avatar, async function(dataUrl) {
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;
                  var hasavatar = dt.filter((e) => e.id === "mother");

                  if (hasavatar.length === 0) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  } else if (hasavatar.length > 0) {
                    if (
                      hasavatar[0].src === undefined ||
                      hasavatar[0].src === ""
                    ) {
                      setTimeout(() => {
                        RenderImg(JSON.stringify(dt));
                      }, 200);
                    }
                  }
                  // sessionStorage.setItem('avatar', file2)
                  // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id === "mother") {
              if (
                arr.mother_avatar !== "" &&
                arr.mother_avatar.includes("https://")
              ) {
                await toDataURL(arr.mother_avatar, async function(dataUrl) {
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;

                  // sessionStorage.setItem('avatar', file2)
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id !== "avatar") {
              if (dt[i].text === toupper("!class") || dt[i].text === "!class") {
                dt[i].text = toupper(arr.class_name);
              }
              if (dt[i].text === toupper("!div") || dt[i].text === "!div") {
                dt[i].text = toupper(arr.divname);
              }
              if (dt[i].text === toupper("!dob") || dt[i].text === "!dob") {
                dt[i].text = convertDate(arr.dob);
              }
              if (
                dt[i].text === toupper("!bloodgroup") ||
                dt[i].text === "!bloodgroup"
              ) {
                dt[i].text = toupper(arr.bloodgroup);
              }
              if (
                dt[i].text === toupper("!adhaar_no") || dt[i].text === "!adhaar_no"
              ) {
                dt[i].text = toupper(arr.adhaar_no);
              }
              if (
                dt[i].text === toupper("!address") ||
                dt[i].text == "!address"
              ) {
                var oldfz = dt[i].fontSize;
                var tx = DecryptED(sid) === "1219" ? (arr.address) : toupper(arr.address);
                var fsize = oldfz;
                var areatxt = tx.length * dt[i].fontSize * dt[i].height;
                var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
                while (areatxt > arear) {
                  fsize = parseFloat(dt[i].fontSize) - 0.1;
                  dt[i].fontSize = fsize;
                  var areatxt = tx.length * fsize * dt[i].height;
                  var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
                  // var areatxt=pixal*(dt[i].scaleY*dt[i].height)
                }
                if (fsize * 2 > oldfz) {
                  dt[i].fontSize = oldfz;
                } else {
                  dt[i].fontSize = fsize * 2;
                }

                dt[i].height = dt[i].scaleY * dt[i].height;
                dt[i].width = dt[i].width * dt[i].scaleX;
                dt[i].scaleY = 1;
                dt[i].scaleX = 1;
                dt[i].text = convertStr(tx);
              }
              if (
                dt[i].text === toupper("!mobile") ||
                dt[i].text === "!mobile"
              ) {
                dt[i].text = arr.mobile;
              }
              if (
                dt[i].text === toupper("!genregid") ||
                dt[i].text === "!genregid"
              ) {
                dt[i].text = arr.genregid;
              }
              if (
                dt[i].text === toupper("!gender") ||
                dt[i].text === "!gender"
              ) {
                dt[i].text = arr.gender;
              }
              if (
                dt[i].text === toupper("!roll_no") ||
                dt[i].text === "!roll_no"
              ) {
                dt[i].text = arr.roll_no;
              }
              if (
                dt[i].text === toupper("!house_details") ||
                dt[i].text === "!house_details"
              ) {
                dt[i].text = arr.house_details;
              }
              if (
                dt[i].text === toupper("!mobile2") ||
                dt[i].text === "!mobile2"
              ) {
                dt[i].text = arr.mobile2;
              }

              if (dt[i].id === "qrcode") {
                var datastr = JSON.stringify([
                  {
                    userid: arr.userid,
                    name: arr.name,
                    class: arr.class_name,
                    div: arr.divname,
                  },
                ]);
                try {
                  dt[i].src = await QRCode.toDataURL(datastr.toString());
                } catch (err) {
                  console.error(err);
                }
              }
              if (dt[i].id === "barcode") {
                var txt = dt[i].textfield.toString();
                if (txt.includes("Userid")) {
                  txt = txt.replace("Userid", arr.userid);
                }
                if (txt.includes("Mobile Number")) {
                  txt = txt.replace("Mobile Number", arr.mobile);
                }
                if (txt.includes("Timestamp")) {
                  txt = txt.replace("Timestamp", Date.now().toString());
                }
                var canvasbar = document.createElement("canvas");
                JsBarcode(canvasbar, txt, { format: "CODE128" });
                try {
                  dt[i].src = canvasbar.toDataURL("image/png");
                } catch (err) {
                  console.error(err);
                }
              }
              setEditable(false);
              setEditclick(false);
            }
            var hasavatar = dt.filter((e) => e.id === "avatar");

            if (hasavatar.length > 0) {
              if (hasavatar[0].src === undefined || hasavatar[0].src === "") {
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              }
            }
            if (hasavatar.length === 0) {
              setTimeout(() => {
                RenderImg(JSON.stringify(dt));
              }, 200);
            }
          } else {
            if (dt[i].text === toupper("!name") || dt[i].text == "!name") {
              setEditable(false);
              dt[i].text = toupper(arr.name);
            }
            if (
              dt[i].text === toupper("!father_name") ||
              dt[i].text == "!father_name"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.father_name);
            }

            if (
              dt[i].text === toupper("!mother_name") ||
              dt[i].text == "!mother_name"
            ) {
              setEditable(false);
              dt[i].text = toupper(arr.mother_name);
            }

            if (dt[i].id === "avatar") {
              if (arr.avatar !== "" && arr.avatar.includes("https://")) {
                // sessionStorage.removeItem('avatar');

                await toDataURL(arr.avatar, async function(dataUrl) {
                  //  console.log('RESULT:', dataUrl)
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  // let FileO = await dataURLtoFile(fil, Static_Data[K].name + '-Avater.png')
                  // let file2 = await resizeFileC(FileO);
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;
                  var hasavatar = dt.filter((e) => e.id === "father");
                  if (
                    hasavatar.length === 0 ||
                    Parent_Data[K].mother_avatar === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  } else if (hasavatar.length > 0) {
                    if (
                      hasavatar[0].src === undefined ||
                      hasavatar[0].src === ""
                    ) {
                      setTimeout(() => {
                        RenderImg(JSON.stringify(dt));
                      }, 200);
                    }
                  }
                  // sessionStorage.setItem('avatar', file2)
                  // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id === "father") {
              if (
                arr.father_avatar.length > 0 &&
                arr.father_avatar.includes("https://")
              ) {
                await toDataURL(arr.father_avatar, async function(dataUrl) {
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;
                  var hasavatar = dt.filter((e) => e.id === "mother");

                  if (hasavatar.length === 0) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  } else if (hasavatar.length > 0) {
                    if (
                      hasavatar[0].src === undefined ||
                      hasavatar[0].src === ""
                    ) {
                      setTimeout(() => {
                        RenderImg(JSON.stringify(dt));
                      }, 200);
                    }
                  }
                  // sessionStorage.setItem('avatar', file2)
                  // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id === "mother") {
              if (
                arr.mother_avatar !== "" &&
                arr.mother_avatar.includes("https://")
              ) {
                await toDataURL(arr.mother_avatar, async function(dataUrl) {
                  var fil = dataUrl.replace(
                    "application/octet-stream",
                    "image/png"
                  );
                  var file2 = await resizedataURL(fil, 300, 300);
                  dt[i].crossOrigin = "";
                  dt[i].src = file2;

                  // sessionStorage.setItem('avatar', file2)
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                });
              } else {
                dt[i].src = "";
                dt[i].crossOrigin = "";
              }
            }
            if (dt[i].id !== "avatar") {
              if (dt[i].text === toupper("!class") || dt[i].text === "!class") {
                dt[i].text = toupper(arr.class_name);
              }
              if (dt[i].text === toupper("!div") || dt[i].text === "!div") {
                dt[i].text = toupper(arr.divname);
              }
              if (dt[i].text === toupper("!dob") || dt[i].text === "!dob") {
                dt[i].text = convertDate(arr.dob);
              }
              if (
                dt[i].text === toupper("!bloodgroup") ||
                dt[i].text === "!bloodgroup"
              ) {
                dt[i].text = toupper(arr.bloodgroup);
              }

              if (
                dt[i].text === toupper("!address") ||
                dt[i].text == "!address"
              ) {
                var oldfz = dt[i].fontSize;
                var tx = toupper(arr.address);
                var fsize = oldfz;
                var areatxt = tx.length * dt[i].fontSize * dt[i].height;
                var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
                while (areatxt > arear) {
                  fsize = parseFloat(dt[i].fontSize) - 0.1;
                  dt[i].fontSize = fsize;
                  var areatxt = tx.length * fsize * dt[i].height;
                  var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
                  // var areatxt=pixal*(dt[i].scaleY*dt[i].height)
                }
                if (fsize * 2 > oldfz) {
                  dt[i].fontSize = oldfz;
                } else {
                  dt[i].fontSize = fsize * 2;
                }

                dt[i].height = dt[i].scaleY * dt[i].height;
                dt[i].width = dt[i].width * dt[i].scaleX;
                dt[i].scaleY = 1;
                dt[i].scaleX = 1;
                dt[i].text = convertStr(tx);
                console.log(dt[i]);
              }
              if (
                dt[i].text === toupper("!mobile") ||
                dt[i].text === "!mobile"
              ) {
                dt[i].text = arr.mobile;
              }
              if (
                dt[i].text === toupper("!mobile2") ||
                dt[i].text === "!mobile2"
              ) {
                dt[i].text = arr.mobile2;
              }

              if (dt[i].id === "qrcode") {
                var datastr = JSON.stringify([
                  {
                    userid: arr.userid,
                    name: arr.name,
                    class: arr.class_name,
                    div: arr.divname,
                  },
                ]);
                try {
                  dt[i].src = await QRCode.toDataURL(datastr.toString());
                } catch (err) {
                  console.error(err);
                }
              }
              if (dt[i].id === "barcode") {
                var txt = dt[i].textfield.toString();
                if (txt.includes("Userid")) {
                  txt = txt.replace("Userid", arr.userid);
                }
                if (txt.includes("Mobile Number")) {
                  txt = txt.replace("Mobile Number", arr.mobile);
                }
                if (txt.includes("Timestamp")) {
                  txt = txt.replace("Timestamp", Date.now().toString());
                }
                var canvasbar = document.createElement("canvas");
                JsBarcode(canvasbar, txt, { format: "CODE128" });
                try {
                  dt[i].src = canvasbar.toDataURL("image/png");
                } catch (err) {
                  console.error(err);
                }
              }
              setEditable(false);
              setEditclick(false);
            }
            var hasavatar = dt.filter((e) => e.id === "avatar");

            if (hasavatar.length > 0) {
              if (hasavatar[0].src === undefined || hasavatar[0].src === "") {
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              }
            }
            if (hasavatar.length === 0) {
              setTimeout(() => {
                RenderImg(JSON.stringify(dt));
              }, 200);
            }
          }

          //  RenderImg(dt)
        }
      }
    }
  };
  const getWidthOfText = (txt, fontname, fontsize) => {
    if (getWidthOfText.c === undefined) {
      getWidthOfText.c = document.createElement("canvas");
      getWidthOfText.ctx = getWidthOfText.c.getContext("2d");
    }
    var fontspec = fontsize + " " + fontname;
    if (getWidthOfText.ctx.font !== fontspec)
      getWidthOfText.ctx.font = fontspec;
    return getWidthOfText.ctx.measureText(txt).width;
  };

  const Load1 = async (K) => {
    console.log(K);

    Clear();
    var dt;
    if (Arrayd != null) {
      dt = JSON.parse(Arrayd.design);
    } else {
      return;
    }

    if (dt === null || dt === undefined) {
      return;
    }
    if (Arrayd.usertype === "Student") {
      console.log("for user type student");

      if (Static_Data != null && Static_Data !== undefined) {
        if (Static_Data.length < 1) {
          window.alert("Student Data Not Avaliable");
          return;
        }
        setUserid(Static_Data[K].userid);
        setLoaderM(true);

        for (let i = 0; i < dt.length; i++) {
          if (dt[i].text === toupper("!adhaar_no") || dt[i].text === "!adhaar_no") {
            setEditable(false);
            dt[i].text = toupper(Static_Data[K].adhaar_no);
          }

           if (dt[i].text === toupper("!name") || dt[i].text === "!name") {
            console.log(toupper(Static_Data[K].name));

            setEditable(false);
            dt[i].text = toupper(Static_Data[K].name);
          }


          if (
            dt[i].text === toupper("!fname_lname") ||
            dt[i].text === "!fname_lname"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].fname_lname) {
              dt[i].text = toupper(Static_Data[K].fname_lname);
            } else {
              dt[i].text = "";
            }
          }

          if (
            dt[i].text === toupper("!appar_id") ||
            dt[i].text === "!appar_id"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].appar_id) {
              dt[i].text = toupper(Static_Data[K].appar_id);
            } else {
              dt[i].text = "";
            }
          }
          if (dt[i].text === toupper("!pen_no") || dt[i].text === "!pen_no") {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].pen_no) {
              dt[i].text = toupper(Static_Data[K].pen_no);
            } else {
              dt[i].text = "";
            }
          }
          // father name && mother name
          if (
            dt[i].text === toupper("!father_name") ||
            dt[i].text === "!father_name"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].father_name) {
              dt[i].text = toupper(Static_Data[K].father_name);
            } else {
              dt[i].text = "";
            }
          }
          // Full_name_mohter_name
          if (
            dt[i].text === toupper("!name_wt_moname") ||
            dt[i].text === "!name_wt_moname"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].name_wt_moname) {
              dt[i].text = toupper(Static_Data[K].name_wt_moname);
            } else {
              dt[i].text = "";
            }
          }

          if (
            dt[i].text === toupper("!mother_name") ||
            dt[i].text === "!mother_name"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[K].mother_name) {
              dt[i].text = toupper(Static_Data[K].mother_name);
            } else {
              dt[i].text = "";
            }
          }

          if (dt[i].id === "avatar") {
            if (
              Static_Data[K].avatar !== "" &&
              Static_Data[K].avatar.includes("https://")
            ) {
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[K].avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");

              toDataURL(newData, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );

                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "father");
                if (
                  hasavatar.length === 0 ||
                  Static_Data[K].mother_avatar === ""
                ) {
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                } else if (hasavatar.length > 0) {
                  if (
                    hasavatar[0].src === undefined ||
                    hasavatar[0].src === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  }
                }
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id === "father") {
            if (
              Static_Data[K].father_avatar.length > 0 &&
              Static_Data[K].father_avatar.includes("https://")
            ) {
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[K].father_avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");
              toDataURL(newData, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "mother");

                if (hasavatar.length === 0) {
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                } else if (hasavatar.length > 0) {
                  if (
                    hasavatar[0].src === undefined ||
                    hasavatar[0].src === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  }
                }
                // sessionStorage.setItem('avatar', file2)
                // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id === "mother") {
            if (
              Static_Data[K].mother_avatar !== "" &&
              Static_Data[K].mother_avatar.includes("https://")
            ) {
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[K].mother_avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");
              toDataURL(newData, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }

          if (dt[i].text === toupper("!class") || dt[i].text === "!class") {
            console.log(toupper(Static_Data[K].class_name));
            dt[i].text = toupper(Static_Data[K].class_name);
          }
          if (dt[i].text === toupper("!div") || dt[i].text === "!div") {
            console.log(toupper(Static_Data[K].divname));

            dt[i].text = toupper(Static_Data[K].divname);
          }
          if (
            dt[i].text === toupper("!genregid") ||
            dt[i].text === "!genregid"
          ) {
            dt[i].text = toupper(Static_Data[K].genregid);
          }
          if (dt[i].text === toupper("!gender") || dt[i].text === "!gender") {
            dt[i].text = toupper(Static_Data[K].gender);
          }
          if (dt[i].text === toupper("!userid") || dt[i].text === "!userid") {
            dt[i].text = Static_Data[K].userid.toString();
          }
          if (dt[i].text === toupper("!roll_no") || dt[i].text === "!roll_no") {
            dt[i].text = toupper(Static_Data[K].roll_no);
          }
          if (
            dt[i].text === toupper("!house_details") ||
            dt[i].text === "!house_details"
          ) {
            dt[i].text = toupper(Static_Data[K].house_details);
          }
          if (dt[i].text === toupper("!dob") || dt[i].text === "!dob") {
            setEditable(false);
            dt[i].text = convertDate(Static_Data[K].dob);
          }
          if (
            dt[i].text === toupper("!bloodgroup") ||
            dt[i].text === "!bloodgroup"
          ) {
            dt[i].text = toupper(Static_Data[K].bloodgroup);
          }
          if (dt[i].text === toupper("!address") || dt[i].text === "!address") {
            let oldfz = dt[i].fontSize;
            let fsize = oldfz;

            let tx = DecryptED(sid) === "1219"? (Static_Data[K].address).replace(/\s+/g, " ").replace(/undefined/gi, "") : toupper(Static_Data[K].address)
  .replace(/\s+/g, " ")
  .replace(/undefined/gi, "");

            let areatxt = LongestAdd * fsize * dt[i].height;
            let arear = dt[i].width * dt[i].scaleY * dt[i].height;

            while (areatxt > arear && fsize > 0.1) {
              fsize -= 0.1;
              areatxt = LongestAdd * fsize * dt[i].height;
            }

            dt[i].fontSize = fsize * 2 > oldfz ? oldfz : fsize * 2;

            // Reset scale
            dt[i].height *= dt[i].scaleY;
            dt[i].width *= dt[i].scaleX;
            dt[i].scaleX = 1;
            dt[i].scaleY = 1;

            dt[i].text = convertStr(tx);
          }

          if (
            dt[i].text === toupper("!paddress") ||
            dt[i].text === "!paddress"
          ) {
            // let tx = toupper(Static_Data[K].paddress).replace(/\s+/g, " ");
            let tx = toupper(Static_Data[K].paddress)
  .replace(/\s+/g, " ")
  .replace(/undefined/gi, ""); 

            let oldfz = dt[i].fontSize;
            let fsize = oldfz;

            let areatxt = tx.length * fsize * dt[i].height;
            let arear = dt[i].width * dt[i].scaleY * dt[i].height;

            while (areatxt > arear && fsize > 0.1) {
              fsize -= 0.1;
              areatxt = tx.length * fsize * dt[i].height;
            }

            dt[i].fontSize = fsize * 2 > oldfz ? oldfz : fsize * 2;

            // Reset scale
            dt[i].height *= dt[i].scaleY;
            dt[i].width *= dt[i].scaleX;
            dt[i].scaleX = 1;
            dt[i].scaleY = 1;

            dt[i].text = convertStr(tx);
          }

          if (dt[i].text == toupper("!mobile") || dt[i].text == "!mobile") {
            dt[i].text = Static_Data[K].mobile.toString();
          }
          if (dt[i].text == toupper("!mobile2") || dt[i].text == "!mobile2") {
            dt[i].text = Static_Data[K].mobile2;
          }
          if (dt[i].id == "qrcode") {
            var datastr = JSON.stringify([
              {
                userid: Static_Data[K].userid,
                name: Static_Data[K].name,
                class: Static_Data[K].class_name,
                div: Static_Data[K].divname,
              },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id === "barcode") {
            var txt = dt[i].textfield ? dt[i].textfield.toString() : "";
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", Static_Data[K].userid);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace("Mobile Number", Static_Data[K].mobile);
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            var canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        let hasavatar = dt.filter(
          (e) =>
            e.id === "avatar" ||
            e.id === "mother_avatar" ||
            e.id === "father_avatar"
        );

        if (hasavatar.length > 0) {
          if (hasavatar[0].src === undefined || hasavatar[0].src === "") {
            setTimeout(() => {
              RenderImg(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length === 0) {
          setTimeout(() => {
            RenderImg(JSON.stringify(dt));
          }, 200);
        }
      }
    } else if (Arrayd.usertype === "staff") {
      if (stafflist != null && stafflist !== undefined) {
        if (stafflist.length < 1) {
          window.alert("Staff Data Not Avaliable");
          return;
        }

        setUserid(stafflist[K].staffid);
        setLoaderM(true);
        setEditable(false);
        setEditclick(false);
        for (let i = 0; i < dt.length; i++) {
          if (dt[i].text === toupper("!name") || dt[i].text === "!name") {
            console.log(dt[i].text);
            setEditable(false);
            dt[i].text = toupper(stafflist[K].name);
          }

           if (
            dt[i].text == toupper("!staffDesig") ||
            dt[i].text == "!staffDesig"
          ) {
            dt[i].text = toupper(stafflist[K].staffDesig);
          }

          if (dt[i].text === toupper("!staff_id") || dt[i].text === "!staff_id") {
            setEditable(false);
            dt[i].text = stafflist[K].staffid.toString();
          }
          if (dt[i].id === "avatar") {
            if (
              stafflist[K].avatar !== "" &&
              stafflist[K].avatar.includes("https://")
            ) {
              var replaceUrl = stafflist[K].avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );

              toDataURL(replaceUrl, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );

                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (
            dt[i].text === toupper("!joining_date") ||
            dt[i].text === "!joining_date"
          ) {
            dt[i].text = toupper(
              moment(stafflist[K].joining_date).format("DD-MM-YYYY")
            );
          }
          if (
            dt[i].text === toupper("!qualification") ||
            dt[i].text === "!qualification"
          ) {
            dt[i].text = toupper(stafflist[K].qualification);
          }
          if (
            dt[i].text === toupper("!employee_id") ||
            dt[i].text === "!employee_id"
          ) {
            dt[i].text = toupper(stafflist[K].employee_id);
          }
          if (dt[i].text === toupper("!gender") || dt[i].text === "!gender") {
            dt[i].text = toupper(stafflist[K].gender);
          }
          if (dt[i].text === toupper("!dob") || dt[i].text === "!dob") {
            setEditable(false);
            dt[i].text = convertDate(stafflist[K].dob);
          }
          if (
            dt[i].text === toupper("!bloodgroup") ||
            dt[i].text === "!bloodgroup"
          ) {
            dt[i].text = toupper(stafflist[K].bloodgroup);
          }

          if (
            dt[i].text === toupper("!emergNo1") ||
            dt[i].text === "!emergNo1"
          ) {
            console.log(dt[i].text);
            setEditable(false);
            dt[i].text = toupper(stafflist[K].emergNo1.toString());
          }
          if (
            dt[i].text === toupper("!emergNo2") ||
            dt[i].text === "!emergNo2"
          ) {
            console.log(dt[i].text);
            setEditable(false);
            dt[i].text = toupper(stafflist[K].emergNo2.toString());
          }
          if (
            dt[i].text === toupper("!emergName1") ||
            dt[i].text === "!emergName1"
          ) {
            console.log(dt[i].text);
            setEditable(false);
            dt[i].text = toupper(stafflist[K].emergName1);
          }
          if (
            dt[i].text === toupper("!emergName2") ||
            dt[i].text === "!emergName2"
          ) {
            console.log(dt[i].text);
            setEditable(false);
            dt[i].text = toupper(stafflist[K].emergName2);
          }
          if (
            dt[i].text === toupper("!designation") ||
            dt[i].text === "!designation"
          ) {
            dt[i].text = toupper(stafflist[K].staff_type);
          }
          if (dt[i].text === toupper("gender") || dt[i].text === "gender") {
            dt[i].text = toupper(stafflist[K].gender);
          }
          if (
            dt[i].text === toupper("qualification") ||
            dt[i].text === "qualification"
          ) {
            dt[i].text = toupper(stafflist[K].qualification);
          }
          if (
            dt[i].text === toupper("employee_id") ||
            dt[i].text === "employee_id"
          ) {
            dt[i].text = toupper(stafflist[K].employee_id);
          }
          if (dt[i].text === toupper("!address") || dt[i].text === "!address") {
            var oldfz = dt[i].fontSize;

            var fsize = oldfz;
            var tx = toupper(stafflist[K].address);
            var areatxt = tx.length * dt[i].fontSize * dt[i].height;
            var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            while (areatxt > arear) {
              fsize = parseFloat(fsize) - 0.1;

              dt[i].fontSize = fsize;
              var areatxt = tx.length * fsize * dt[i].height;
              var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            }
            if (fsize * 2 > oldfz) {
              dt[i].fontSize = oldfz;
            } else {
              dt[i].fontSize = fsize * 2;
            }
            dt[i].height = dt[i].scaleY * dt[i].height;
            dt[i].width = dt[i].width * dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;
            dt[i].text = convertStr(tx);
            console.log(dt[i]);
          }
          if (dt[i].text === toupper("!mobile") || dt[i].text === "!mobile") {
            dt[i].text = stafflist[K].mobile.toString();
          }
          if (dt[i].text === toupper("!mobile2") || dt[i].text === "!mobile2") {
            dt[i].text = stafflist[K].mobile2.toString();
          }
          if (dt[i].id === "qrcode") {
            var datastr = JSON.stringify([
              { userid: stafflist[K].staffid, name: stafflist[K].name },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id === "barcode") {
            var txt = dt[i].textfield.toString();
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", stafflist[K].staffid);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace("Mobile Number", stafflist[K].mobile);
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            let canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        let hasavatar = dt.filter((e) => e.id === "avatar");

        if (hasavatar.length > 0) {
          if (hasavatar[0].src === undefined || hasavatar[0].src === "") {
            setTimeout(() => {
              RenderImg(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length == 0) {
          setTimeout(() => {
            RenderImg(JSON.stringify(dt));
          }, 200);
        }
      }
    } else if (Arrayd.usertype === "Parent") {
      console.log("for user type parent");
      if (Parent_Data != null && Parent_Data !== undefined) {
        if (Parent_Data.length < 1) {
          window.alert("Parent Data Not Avaliable");
          return;
        }
        setUserid(Parent_Data[K].userid);

        console.log(Parent_Data[K].userid);
        setLoaderM(true);

        for (let i = 0; i < dt.length; i++) {
          console.log("for user type parent");

          if (dt[i].text === toupper("!name") || dt[i].text === "!name") {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[K].name);
          }
          if (
            dt[i].text === toupper("!fathername") ||
            dt[i].text === "!fathername"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[K].father_name);
          }
          if (
            dt[i].text === toupper("!mothername") ||
            dt[i].text === "!mothername"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[K].mother_name);
          }
          if (
            dt[i].text === toupper("!guardianname") ||
            dt[i].text === "!guardianname"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[K].guardian_name);
          }
          if (
            dt[i].text === toupper("!guardianrelation") ||
            dt[i].text === "!guardianrelation"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[K].guardian_relation);
          }
          if (dt[i].id === "avatar") {
            if (
              Parent_Data[K].avatar !== "" &&
              Parent_Data[K].avatar.includes("https://")
            ) {
              let replaceUrl = Parent_Data[K].avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );
              console.log(replaceUrl);
              toDataURL(replaceUrl, async function(dataUrl) {
                //  console.log('RESULT:', dataUrl)
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                // let FileO = await dataURLtoFile(fil, Static_Data[K].name + '-Avater.png')
                // let file2 = await resizeFileC(FileO);
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "father");
                if (
                  hasavatar.length === 0 ||
                  Parent_Data.mother_avatar === ""
                ) {
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                } else if (hasavatar.length > 0) {
                  if (
                    hasavatar[0].src === undefined ||
                    hasavatar[0].src === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  }
                }
                // sessionStorage.setItem('avatar', file2)
                // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id === "father") {
            if (
              Parent_Data[K].father_avatar.length > 0 &&
              Parent_Data[K].father_avatar.includes("https://")
            ) {
              console.log(Parent_Data[K].father_avatar);
              let replaceUrl = Parent_Data[K].father_avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );

              console.log(replaceUrl);
              toDataURL(replaceUrl, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "mother");

                if (hasavatar.length === 0) {
                  setTimeout(() => {
                    RenderImg(JSON.stringify(dt));
                  }, 200);
                } else if (hasavatar.length > 0) {
                  if (
                    hasavatar[0].src === undefined ||
                    hasavatar[0].src === ""
                  ) {
                    setTimeout(() => {
                      RenderImg(JSON.stringify(dt));
                    }, 200);
                  }
                }
                // sessionStorage.setItem('avatar', file2)
                // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id === "mother") {
            if (
              Parent_Data[K].mother_avatar !== "" &&
              Parent_Data[K].mother_avatar.includes("https://")
            ) {
              let replaceUrl = Parent_Data[K].mother_avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );

              toDataURL(replaceUrl, async function(dataUrl) {
             var fil = dataUrl ? dataUrl.replace("application/octet-stream", "image/png") : dataUrl;
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id === "guardian") {
            if (
              Parent_Data[K].guardian_avatar !== "" &&
              Parent_Data[K].guardian_avatar.includes("https://")
            ) {
              let replaceUrl = Parent_Data[K].guardian_avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );
              toDataURL(replaceUrl, async function(dataUrl) {
              var fil = dataUrl ? dataUrl.replace("application/octet-stream", "image/png") : dataUrl;
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].text === toupper("!class") || dt[i].text === "!class") {
            dt[i].text = toupper(Parent_Data[K].class_name);
          }
          if (dt[i].text === toupper("!div") || dt[i].text === "!div") {
            dt[i].text = toupper(Parent_Data[K].divname);
          }
          if (dt[i].text === toupper("!dob") || dt[i].text === "!dob") {
            setEditable(false);
            dt[i].text = convertDate(Parent_Data[K].dob);
          }
          if (
            dt[i].text === toupper("!bloodgroup") ||
            dt[i].text === "!bloodgroup"
          ) {
            dt[i].text = toupper(Parent_Data[K].bloodgroup);
          }
          if (dt[i].text === toupper("!address") || dt[i].text === "!address") {
            var oldfz = dt[i].fontSize;

            var fsize = oldfz;
            var tx = toupper(Parent_Data[K].address);
            var areatxt = tx.length * dt[i].fontSize * dt[i].height;
            var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            while (areatxt > arear) {
              fsize = parseFloat(fsize) - 0.1;

              dt[i].fontSize = fsize;
              var areatxt = tx.length * fsize * dt[i].height;
              var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            }
            if (fsize * 2 > oldfz) {
              dt[i].fontSize = oldfz;
            } else {
              dt[i].fontSize = fsize * 2;
            }
            dt[i].height = dt[i].scaleY * dt[i].height;
            dt[i].width = dt[i].width * dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;
            dt[i].text = convertStr(tx);
          }
          if (dt[i].text == toupper("!mobile") || dt[i].text == "!mobile") {
            dt[i].text = Parent_Data[K].mobile.toString();
          }
          if (dt[i].text == toupper("!mobile2") || dt[i].text == "!mobile2") {
            console.log(Parent_Data[K].mobile2.toString());

            dt[i].text = Parent_Data[K].mobile2.toString();
          }
          if (dt[i].id == "qrcode") {
            var datastr = JSON.stringify([
              {
                userid: Parent_Data[K].userid,
                name: Parent_Data[K].name,
                class: Parent_Data[K].class_name,
                div: Parent_Data[K].divname,
              },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id == "barcode") {
            var txt = dt[i].textfield.toString();
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", Parent_Data[K].userid);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace("Mobile Number", Parent_Data[K].mobile);
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            var canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        let hasavatar = dt.filter(
          (e) =>
            e.id === "avatar" ||
            e.id === "mother_avatar" ||
            e.id === "father_avatar"
        );

        if (hasavatar.length > 0) {
          if (hasavatar[0].src === undefined || hasavatar[0].src === "") {
            setTimeout(() => {
              RenderImg(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length === 0) {
          setTimeout(() => {
            RenderImg(JSON.stringify(dt));
          }, 200);
        }
      }
    }
  };

  const RenderImg = (json) => {
    return new Promise((resolve, reject) => {
      refInput.current.handler.importJSON(json, () => {
        refInput.current.canvas.renderAll.bind(
          refInput.current.canvas.renderAll
        );
        var interval = setTimeout(function() {
          clearInterval(interval);
          refInput.current.canvas.renderAll();
          setLoaderM(false);
        }, 200);
      });
      resolve();
    });
  };

  const handleSaveClose = () => {
    setSaved(false);
  };
  const handleLoadClose = () => {
    setMainModel(false);
    setLoadD(false);
  };

  const handleFinalClose = () => {
    setFinalD(false);
  };

  const Clear = () => {
    if (refInput.current !== undefined) refInput.current.handler.clear();
  };
  const FontSize = (val) => {
    // setTOpen(true);
    if (
      refInput.current.canvas.getActiveObject() !== undefined &&
      refInput.current.canvas.getActiveObject() != null &&
      refInput.current.canvas.getActiveObject().id != "back" &&
      refInput.current.canvas.getActiveObject().id != "avatar"
    ) {
      if ((refInput.current.canvas.getActiveObject().type = "textbox")) {
        //  console.log(refInput.current.canvas.getActiveObject())
        refInput.current.canvas.getActiveObject().set("fontSize", val);
        refInput.current.canvas.requestRenderAll();
      }
    }
  };
  const FontAC = (val) => {
    // setTOpen(true);
    // console.log(val)

    if (
      refInput.current.canvas.getActiveObject() !== undefined &&
      refInput.current.canvas.getActiveObject().id !== "back" &&
      refInput.current.canvas.getActiveObject().id !== "avatar"
    ) {
      refInput.current.canvas.getActiveObject().set("textAlign", "center");
      refInput.current.canvas.requestRenderAll();
    }
  };
  const FontColor = (val) => {
    // setTOpen(true);

    console.log(val);
    if (
      refInput.current.canvas.getActiveObject() !== undefined &&
      refInput.current.canvas.getActiveObject().id !== "back" &&
      refInput.current.canvas.getActiveObject().id !== "avatar"
    ) {
      refInput.current.canvas.getActiveObject().set("fill", val);
      refInput.current.canvas.requestRenderAll();
    }
  };

  useEffect(() => {
    if (color != null) {
      if (refInput.current.canvas.getActiveObject() != undefined) {
        if (refInput.current.canvas.getActiveObject().id == "rect") {
          refInput.current.canvas.getActiveObject().set("stroke", color);
          refInput.current.canvas.requestRenderAll();
        }
        if (refInput.current.canvas.getActiveObject().id == "line") {
          refInput.current.canvas.getActiveObject().set("stroke", color);
          refInput.current.canvas.requestRenderAll();
        }
        if (refInput.current.canvas.getActiveObject().id == "tri") {
          refInput.current.canvas.getActiveObject().set("stroke", color);
          refInput.current.canvas.requestRenderAll();
        }
        if (refInput.current.canvas.getActiveObject().id == "cir") {
          refInput.current.canvas.getActiveObject().set("stroke", color);
          refInput.current.canvas.requestRenderAll();
        }
      }
    }
  }, [color]);
  const FontAL = (val) => {
    // setTOpen(true);
    if (
      refInput.current.canvas.getActiveObject() != undefined &&
      refInput.current.canvas.getActiveObject().id != "back" &&
      refInput.current.canvas.getActiveObject().id != "avatar"
    ) {
      refInput.current.canvas.getActiveObject().set("textAlign", "left");
      refInput.current.canvas.requestRenderAll();
    }
  };
  const FontB = (val) => {
    // setTOpen(true);
    // console.log(val)
    if (
      refInput.current.canvas.getActiveObject() != undefined &&
      refInput.current.canvas.getActiveObject().id != "back" &&
      refInput.current.canvas.getActiveObject().id != "avatar"
    ) {
      if (val === true) {
        refInput.current.canvas.getActiveObject().set("fontWeight", "bold");
      } else {
        refInput.current.canvas.getActiveObject().set("fontWeight", "normal");
      }
      refInput.current.canvas.requestRenderAll();
    }
  };
  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  const FontFamily = (val) => {
    // setTOpen(true);
    console.log(val);
    refInput.current.canvas.getActiveObject().set({
      fontFamily: val,
      styles: {
        fontFamily: val,
      },
    });
    refInput.current.canvas.requestRenderAll();
    console.log(refInput.current.canvas.getActiveObject());
  };
  const [loader, setLoader] = React.useState(false);
  const [loaderAll, setLoaderAll] = React.useState(false);
  // for k6kb9_stud_data_id table
  const getList1 = () => {
    var s = window.confirm("did you save this design?");
    if (s) {
      const did = Arrayd.design_id;
      const data = {
        sid: DecryptED(sid),
        classid: Sclass,
        divid: Sdiv,
        did: did,
      };

      const data2 = {
        sid: DecryptED(sid),
        classid: classDiv.SclassId,
        divid: classDiv.SdivId,
        did: Arrayd.design_id,
      };
      setEditclick(false);
      setLoader(true);
      setOpenTC(false);
      if (Arrayd.usertype === "Student") {
        if (did != undefined && did != "") {
          axios({
            method: "POST",
            url: `${configUrl2}/api/idcard/proof/student`,
            data: data2,
            headers: {
              Authorization: `${token}`,
            },
          }).then((res) => {
            setStaticData(res.data);
            const Ar = [];
            let B = 0;
            res.data.forEach((item) => {
              Ar.push(item.address); // Push the "name" property into the Ar array
            });

            setLadd(Ar);
            if (res.data != undefined) {
              setTotal(res.data.length);
              console.log(res.data.length);
            } else setTotal(0);
            Clear();
            setLoader(false);
          });
        }
      } else {
        axios({
          method: "POST",
          url: `${configUrl2}/api/idcard/proof/parent`,
          data,
          headers: {
            Authorization: `${token}`,
          },
        })
          .then((res) => {
            setParentData(res.data);
            if (res.data != undefined) {
              setTotal(res.data.length);
            } else setTotal(0);
            Clear();

            setLoader(false);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
    // Load(K)
  };

  const getstafflist = () => {
    const filteredData = [];
    staff.forEach((role) => {
      if (StaffD.hasOwnProperty(role)) {
        const filteredStaff = StaffD[role].filter((staff) => {
          return true;
        });
        filteredData.push(...filteredStaff);
      }
    });

    setStaffList(filteredData);
    setTotal(filteredData.length);
    setStaffClick(staffclick + 1);
  };

  const getList = (classnm, div) => {
    // console.log(classnm+'-->'+div)
    setLoader(true);
    axios
      .post(configUrl, {
        fun_name: "GetUserDataID",
        sid: sid,
        classnm: classnm,
        divnm: div,
      })
      .then((res) => {
        // setStaticData(res)
        setTotal(res.data.Id.length);
        Clear();
        if (res.data.Id.length === 0) {
          setLoader(false);
          preview();
        } else if (res.data.Id.length > 0) {
          console.log(res.data.Id);
          const random = Math.floor(Math.random() * res.data.Id.length);
          setRandomData(res.data.Id[random]);
        }
        setLoader(false);
      });
    // Load(K)
  };

  // Laregest address for both student and Parent Design Id
  const Largest = () => {
    // let d = Static_Data ? Static_Data : Parent_Data;
    const max = Static_Data.reduce(function(prev, curr) {
      return prev.address.length > curr.address.length ? prev : curr;
    });
    Load(max);
    // setK(parseInt(max.id)-1)
  };

  const Largest2 = () => {
    // let d = Static_Data ? Static_Data : Parent_Data;
    const max = Parent_Data.reduce(function(prev, curr) {
      return prev.address.length > curr.address.length ? prev : curr;
    });
    Load(max);
    // setK(parseInt(max.id)-1)
  };

  useEffect(() => {
    refInput.current.handler.selectById("back");
    if (refInput.current.canvas.getActiveObject() != undefined) {
      if (refInput.current.canvas.getActiveObject().id == "back") {
        refInput.current.canvas.getActiveObject().lockMovementY = islock;
        refInput.current.canvas.getActiveObject().lockMovementX = islock;
        refInput.current.canvas.getActiveObject().hasControls = !islock;
      }
    }
  }, [islock]);

  const handlebarcode = (f, f2, f3) => {
    var canvasbar = document.createElement("canvas");
    JsBarcode(canvasbar, f + f2 + f3, { format: "CODE128" });
    var imgobj = CanvasObject.image.create({
      width: 20,
      height: 20,
      left: 50,
      scaleX: 0.3,
      scaleY: 0.3,
      top: 70,
      editable: true,
      src: canvasbar.toDataURL("image/png"),
      id: "barcode",
      textfield: f + f2 + f3,
    });

    refInput.current.handler.add(imgobj);
  };
  const handlebarcodeClose = () => {
    setTOpen(false);
  };
  // const Expr = () => {
  //   setExpress(true)
  // }
  // const Store = [];

  const Setforclass = async (g) => {
    setLoaderAll(true);
    var dt = JSON.parse(Arrayd.design);
    // console.log(dt);

    if (dt === null || dt === undefined) {
      Swal.fire("Error", "Design not Found", "Error");
      setLoaderAll(false);
      return;
    } else if (
      (Static_Data === null || Static_Data === undefined) &&
      (stafflist == null || stafflist === undefined) &&
      (Parent_Data === null || Parent_Data === undefined)
    ) {
      Swal.fire(
        "Info",
        "Please select class and div or staff type then click on preview befour apply to all div",
        "info"
      );
      setLoaderAll(false);
      return;
    } else {
      if (Static_Data != null && Static_Data != undefined) {
        for (let i = 0; i < dt.length; i++) {
          if (dt[i].text == toupper("!name") || dt[i].text == "!name") {
            setEditable(false);
            dt[i].text = toupper(Static_Data[kl].name);
          }

            if (dt[i].text == toupper("!adhaar_no") || dt[i].text == "!adhaar_no") {
            setEditable(false);
            dt[i].text = toupper(Static_Data[kl].adhaar_no);
          }

          if (
            dt[i].text === toupper("!father_name") ||
            dt[i].text === "!father_name"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[kl].father_name) {
              dt[i].text = toupper(Static_Data[kl].father_name);
            } else {
              dt[i].text = "";
            }
          }
          //
          if (
            dt[i].text === toupper("!name_wt_moname") ||
            dt[i].text === "!name_wt_moname"
          ) {
            setEditable(false);
            if (Static_Data[kl] && Static_Data[kl].name_wt_moname) {
              dt[i].text = toupper(Static_Data[kl].name_wt_moname);
            } else {
              dt[i].text = "";
            }
          }

          if (
            dt[i].text === toupper("!fname_lname") ||
            dt[i].text === "!fname_lname"
          ) {
            setEditable(false);
            if (Static_Data[kl] && Static_Data[kl].fname_lname) {
              dt[i].text = toupper(Static_Data[kl].fname_lname);
            } else {
              dt[i].text = "";
            }
          }
          if (
            dt[i].text === toupper("!appar_id") ||
            dt[i].text === "!appar_id"
          ) {
            setEditable(false);
            if (Static_Data[kl] && Static_Data[kl].appar_id) {
              dt[i].text = toupper(Static_Data[kl].appar_id);
            } else {
              dt[i].text = "";
            }
          }
          if (dt[i].text === toupper("!pen_no") || dt[i].text === "!pen_no") {
            setEditable(false);
            if (Static_Data[kl] && Static_Data[kl].pen_no) {
              dt[i].text = toupper(Static_Data[kl].pen_no);
            } else {
              dt[i].text = "";
            }
          }

          if (
            dt[i].text === toupper("!mother_name") ||
            dt[i].text === "!mother_name"
          ) {
            setEditable(false);
            if (Static_Data[K] && Static_Data[kl].mother_name) {
              dt[i].text = toupper(Static_Data[kl].mother_name);
            } else {
              dt[i].text = "";
            }
          }
          if (dt[i].id == "avatar") {
            //.avatar.includes("https://")
            if (Static_Data[kl].avatar != "") {
              console.log();
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[kl].avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");

              sessionStorage.removeItem("avatar");
              try {
                await loadImage(newData);
                toDataURL(newData, async function(dataUrl) {
                  if (dataUrl) {
                    var fil = dataUrl.replace(
                      "application/octet-stream",
                      "image/png"
                    );
                    var file2 = await resizedataURL(fil, 300, 300);
                    dt[i].crossOrigin = "";
                    dt[i].src = file2;

                    var hasavatar = dt.filter((e) => e.id === "father");

                    if (
                      hasavatar.length == 0 ||
                      Static_Data[kl].mother_avatar == ""
                    ) {
                      setTimeout(() => {
                        RenderImg2(JSON.stringify(dt));
                      }, 200);
                    } else if (hasavatar.length > 0) {
                      if (
                        hasavatar[0].src == undefined ||
                        hasavatar[0].src == ""
                      ) {
                        setTimeout(() => {
                          RenderImg2(JSON.stringify(dt));
                        }, 200);
                      }
                    }
                  } else {
                    console.error("Failed to convert image URL to data URL.");
                    dt[i].src = ""; // Handle the case where the data URL conversion failed
                    dt[i].crossOrigin = "";
                  }
                });
              } catch (error) {
                console.error("Image loading failed for URL:", newData, error);
                dt[i].src = ""; // Or set a default/fallback image URL
                dt[i].crossOrigin = "";
              }
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id == "father") {
            if (
              Static_Data[kl].father_avatar.length > 0 &&
              Static_Data[kl].father_avatar.includes("https://")
            ) {
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[kl].father_avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");

              await toDataURL(newData, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "mother");

                if (hasavatar.length == 0) {
                  setTimeout(() => {
                    RenderImg2(JSON.stringify(dt));
                  }, 200);
                } else if (hasavatar.length > 0) {
                  if (hasavatar[0].src == undefined || hasavatar[0].src == "") {
                    setTimeout(() => {
                      RenderImg2(JSON.stringify(dt));
                    }, 200);
                  }
                }
                // sessionStorage.setItem('avatar', file2)
                // setTimeout(() => { RenderImg(JSON.stringify(dt)) }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].id == "mother") {
            if (
              Static_Data[kl].mother_avatar != "" &&
              Static_Data[kl].mother_avatar.includes("https://")
            ) {
              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              const newData = Static_Data[kl].mother_avatar
                .replace(url1, "https://files.prisms.in/")
                .replace(url2, "https://files.prisms.in/");

              await toDataURL(newData, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg2(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].text == toupper("!class") || dt[i].text == "!class") {
            dt[i].text = toupper(Static_Data[kl].class_name);
          }
          if (dt[i].text == toupper("!div") || dt[i].text == "!div") {
            dt[i].text = toupper(Static_Data[kl].divname);
          }
          if (dt[i].text == toupper("!userid") || dt[i].text == "!userid") {
            dt[i].text = Static_Data[kl].userid.toString();
          }
          if (dt[i].text == toupper("!dob") || dt[i].text == "!dob") {
            setEditable(false);
            dt[i].text = convertDate(Static_Data[kl].dob);
          }
          if (
            dt[i].text === toupper("!genregid") ||
            dt[i].text === "!genregid"
          ) {
            setEditable(false);
            dt[i].text = toupper(Static_Data[kl].genregid);
          }
          if (
            dt[i].text === toupper("!house_details") ||
            dt[i].text === "!house_details"
          ) {
            dt[i].text = toupper(Static_Data[kl].house_details);
          }
          if (dt[i].text === toupper("!roll_no") || dt[i].text === "!roll_no") {
            dt[i].text = toupper(Static_Data[kl].roll_no);
          }
          if (dt[i].text === toupper("!gender") || dt[i].text === "!gender") {
            dt[i].text = toupper(Static_Data[kl].gender);
          }
          if (
            dt[i].text == toupper("!bloodgroup") ||
            dt[i].text == "!bloodgroup"
          ) {
            dt[i].text = toupper(Static_Data[kl].bloodgroup);
          }

          if (dt[i].text === toupper("!address") || dt[i].text === "!address") {
            const oldfz = dt[i].fontSize;
            let fsize = oldfz;

            let tx = DecryptED(sid) === "1219"? (Static_Data[kl].address).replace(/\s+/g, " ")
  .replace(/undefined/gi, ""):toupper(Static_Data[kl].address).replace(/\s+/g, " ")
  .replace(/undefined/gi, "");
            let areatxt = LongestAdd * fsize * dt[i].height;
            let arear = dt[i].width * dt[i].scaleY * dt[i].height;

            while (areatxt > arear && fsize > 0.1) {
              fsize -= 0.1;
              areatxt = LongestAdd * fsize * dt[i].height;
            }

            dt[i].fontSize = fsize * 2 > oldfz ? oldfz : fsize * 2;

            dt[i].height *= dt[i].scaleY;
            dt[i].width *= dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;

            dt[i].text = convertStr(tx);
          }

          if (
            dt[i].text === toupper("!paddress") ||
            dt[i].text === "!paddress"
          ) {
            const oldfz = dt[i].fontSize;
            let fsize = oldfz;

   let tx = toupper(Static_Data[kl].paddress)
  .replace(/\s+/g, " ")
  .replace(/undefined/gi, "");             let areatxt = tx.length * fsize * dt[i].height;
            let arear = dt[i].width * dt[i].scaleY * dt[i].height;

            while (areatxt > arear && fsize > 0.1) {
              fsize -= 0.1;
              areatxt = tx.length * fsize * dt[i].height;
            }

            dt[i].fontSize = fsize * 2 > oldfz ? oldfz : fsize * 2;

            dt[i].height *= dt[i].scaleY;
            dt[i].width *= dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;

            dt[i].text = convertStr(tx);

            console.log(dt[i]);
          }

          if (dt[i].text == toupper("!mobile") || dt[i].text === "!mobile") {
            dt[i].text = Static_Data[kl].mobile.toString();
          }
          if (dt[i].text == toupper("!mobile2") || dt[i].text === "!mobile2") {
            dt[i].text = Static_Data[kl].mobile2;
          }
          if (dt[i].id == "qrcode") {
            var datastr = JSON.stringify([
              {
                userid: Static_Data[kl].userid,
                name: Static_Data[kl].name,
                class: Static_Data[kl].class_name,
                div: Static_Data[kl].divname,
              },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id == "barcode") {
            var txt = dt[i].textfield.toString();
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", Static_Data[kl].userid);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace("Mobile Number", Static_Data[kl].mobile);
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            var canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        var hasavatar = dt.filter(
          (e) =>
            e.id === "avatar" ||
            e.id === "mother_avatar" ||
            e.id === "father_avatar"
        );

        if (hasavatar.length > 0) {
          if (hasavatar[0].src == undefined || hasavatar[0].src == "") {
            setTimeout(() => {
              RenderImg2(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length == 0) {
          setTimeout(() => {
            RenderImg2(JSON.stringify(dt));
          }, 200);
        }
      }
      // PARENT ID CARD APPLY DESIGN
      else if (Parent_Data != null && Parent_Data != undefined) {
        for (let i = 0; i < dt.length; i++) {
          if (dt[i].text == toupper("!name") || dt[i].text == "!name") {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[kl].name);
          }
          if (
            dt[i].text == toupper("!fathername") ||
            dt[i].text == "!fathername"
          ) {
            dt[i].text = toupper(Parent_Data[kl].father_name);
          }
          if (
            dt[i].text == toupper("!mothername") ||
            dt[i].text == "!mothername"
          ) {
            dt[i].text = toupper(Parent_Data[kl].mother_name);
          }
          if (
            dt[i].text === toupper("!guardianname") ||
            dt[i].text === "!guardianname"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[kl].guardian_name);
          }
          if (
            dt[i].text === toupper("!guardianrelation") ||
            dt[i].text === "!guardianrelation"
          ) {
            setEditable(false);
            dt[i].text = toupper(Parent_Data[kl].guardian_relation);
          }
        if (dt[i].id == "avatar") {
  if (
    Parent_Data[kl].avatar != null && // Add null check
    Parent_Data[kl].avatar != ""
  ) {
    let url1 = "https://topschool-attachments.s3.amazonaws.com/";
    let url2 = "https://s3.amazonaws.com/topschool-attachments/";

    const newData = Parent_Data[kl].avatar
      .replace(url1, "https://files.prisms.in/")
      .replace(url2, "https://files.prisms.in/");

    sessionStorage.removeItem("avatar");
    await toDataURL(newData, async function(dataUrl) {
var fil = dataUrl ? dataUrl.replace("application/octet-stream", "image/png") : dataUrl;
      var file2 = await resizedataURL(fil, 300, 300);
      dt[i].crossOrigin = "";
      dt[i].src = file2;
      
      var hasavatar = dt.filter((e) => e.id === "father");
      if (
        hasavatar.length == 0 ||
        Parent_Data[kl].mother_avatar == null || // Add null check here too
        Parent_Data[kl].mother_avatar == ""
      ) {
        setTimeout(() => {
          RenderImg2(JSON.stringify(dt));
        }, 500);
      } else if (hasavatar.length > 0) {
        if (hasavatar[0].src == undefined || hasavatar[0].src == "") {
          setTimeout(() => {
            RenderImg2(JSON.stringify(dt));
          }, 500);
        }
      }
    });
  } else {
    dt[i].src = "";
    dt[i].crossOrigin = "";
  }
}
         if (dt[i].id == "father") {
  if (
    Parent_Data[kl].father_avatar != null && // Add null check
    Parent_Data[kl].father_avatar.length > 0 &&
    Parent_Data[kl].father_avatar.includes("https://")
  ) {
    let url1 = "https://topschool-attachments.s3.amazonaws.com/";
    let url2 = "https://s3.amazonaws.com/topschool-attachments/";
    let replaceUrl = Parent_Data[kl].father_avatar
      .replace(url1, "https://files.prisms.in/")
      .replace(url2, "https://files.prisms.in/");
    
    await toDataURL(replaceUrl, async function(dataUrl) {
var fil = dataUrl ? dataUrl.replace("application/octet-stream", "image/png") : dataUrl;
      var file2 = await resizedataURL(fil, 300, 300);
      dt[i].crossOrigin = "";
      dt[i].src = file2;
      
      var hasavatar = dt.filter((e) => e.id === "mother");

      if (hasavatar.length == 0) {
        setTimeout(() => {
          RenderImg2(JSON.stringify(dt));
        }, 500);
      } else if (hasavatar.length > 0) {
        if (hasavatar[0].src == undefined || hasavatar[0].src == "") {
          setTimeout(() => {
            RenderImg2(JSON.stringify(dt));
          }, 500);
        }
      }
    });
  } else {
    dt[i].src = "";
    dt[i].crossOrigin = "";
  }
}
         if (dt[i].id == "mother") {
  if (
    Parent_Data[kl].mother_avatar != null && // Add this check
    Parent_Data[kl].mother_avatar != "" &&
    Parent_Data[kl].mother_avatar.includes("https://")
  ) {
    let url1 = "https://topschool-attachments.s3.amazonaws.com/";
    let url2 = "https://s3.amazonaws.com/topschool-attachments/";
    let replaceUrl = Parent_Data[kl].mother_avatar
      .replace(url1, "https://files.prisms.in/")
      .replace(url2, "https://files.prisms.in/");
    
    await toDataURL(replaceUrl, async function(dataUrl) {
var fil = dataUrl ? dataUrl.replace("application/octet-stream", "image/png") : dataUrl;
      var file2 = await resizedataURL(fil, 300, 300);
      dt[i].crossOrigin = "";
      dt[i].src = file2;
      
      setTimeout(() => {
        RenderImg2(JSON.stringify(dt));
      }, 500);
    });
  } else {
    dt[i].src = "";
    dt[i].crossOrigin = "";
  }
}
          if (dt[i].id == "guardian") {
            if (
              Parent_Data[kl].guardian_avatar != "" &&
              Parent_Data[kl].guardian_avatar.includes("https://")
            ) {


              let url1 = "https://topschool-attachments.s3.amazonaws.com/";
              let url2 = "https://s3.amazonaws.com/topschool-attachments/";

              let replaceUrl = Parent_Data[kl].guardian_avatar.replace(
                url1,
                "https://files.prisms.in/"
              ).replace(
                url2,
                "https://files.prisms.in/"
              );
              await toDataURL(replaceUrl, async function(dataUrl) {
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg2(JSON.stringify(dt));
                }, 500);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }
          if (dt[i].text == toupper("!class") || dt[i].text == "!class") {
            dt[i].text = toupper(Parent_Data[kl].class_name);
          }
          if (dt[i].text == toupper("!div") || dt[i].text == "!div") {
            dt[i].text = toupper(Parent_Data[kl].divname);
          }
          if (dt[i].text == toupper("!dob") || dt[i].text == "!dob") {
            setEditable(false);
            dt[i].text = convertDate(Parent_Data[kl].dob);
          }
          if (
            dt[i].text == toupper("!bloodgroup") ||
            dt[i].text == "!bloodgroup"
          ) {
            dt[i].text = toupper(Parent_Data[kl].bloodgroup);
          }
          if (dt[i].text == toupper("!address") || dt[i].text == "!address") {
            var oldfz = dt[i].fontSize;

            var fsize = oldfz;
            var tx = toupper(Parent_Data[kl].address);
            var areatxt = tx.length * dt[i].fontSize * dt[i].height;
            var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            while (areatxt > arear) {
              fsize = parseFloat(fsize) - 0.1;

              dt[i].fontSize = fsize;
              var areatxt = tx.length * fsize * dt[i].height;
              var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            }
            if (fsize * 2 > oldfz) {
              dt[i].fontSize = oldfz;
            } else {
              dt[i].fontSize = fsize * 2;
            }
            dt[i].height = dt[i].scaleY * dt[i].height;
            dt[i].width = dt[i].width * dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;
            dt[i].text = convertStr(tx);
          }
          if (dt[i].text == toupper("!mobile") || dt[i].text === "!mobile") {
            dt[i].text = Parent_Data[kl].mobile.toString();
          }
          if (dt[i].text == toupper("!mobile2") || dt[i].text === "!mobile2") {
            dt[i].text = Parent_Data[kl].mobile2.toString();
          }

          if (dt[i].id == "qrcode") {
            var datastr = JSON.stringify([
              {
                userid: Parent_Data[kl].userid,
                name: Parent_Data[kl].name,

                class: Parent_Data[kl].class_name,
                div: Parent_Data[kl].divname,
              },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id == "barcode") {
            var txt = dt[i].textfield.toString();
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", Parent_Data[kl].userid);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace(
                "Mobile Number",
                Parent_Data[kl].mobile.toString()
              );
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            var canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        let hasavatar = dt.filter(
          (e) =>
            e.id === "avatar" ||
            e.id === "mother_avatar" ||
            e.id === "father_avatar"
        );

        if (hasavatar.length > 0) {
          if (hasavatar[0].src == undefined || hasavatar[0].src == "") {
            setTimeout(() => {
              RenderImg2(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length == 0) {
          setTimeout(() => {
            RenderImg2(JSON.stringify(dt));
          }, 200);
        }
      } else if (stafflist) {
        //staff
        //stafflist != null && stafflist != undefined
        // console.log(stafflist);
        for (let i = 0; i < dt.length; i++) {
          if (dt[i].text == toupper("!name") || dt[i].text == "!name") {
            setEditable(false);
            dt[i].text = toupper(stafflist[kl].name);
          }

          
          // if (dt[i].text.toupper("!staffDesig") || dt[i].text === "!staffDesig") {
          //   setEditable(false);
          //   dt[i].text = stafflist[kl].staffDesig;
          // } else {
          //   dt[i].text = "";
          // }

          if (
            dt[i].text == toupper("!emergName1") ||
            dt[i].text == "!emergName1"
          ) {
            setEditable(false);
            dt[i].text = toupper(stafflist[kl].emergName1);
          }

          if (
            dt[i].text == toupper("!emergName2") ||
            dt[i].text == "!emergName2"
          ) {
            setEditable(false);
            dt[i].text = toupper(stafflist[kl].emergName2);
          }

          if (dt[i].text == toupper("!emergNo1") || dt[i].text == "!emergNo1") {
            setEditable(false);
            dt[i].text = stafflist[kl].emergNo1.toString();
          }
          if (dt[i].text == toupper("!emergNo2") || dt[i].text == "!emergNo2") {
            setEditable(false);
            dt[i].text = stafflist[kl].emergNo2.toString();
          }

          if (dt[i].text == toupper("!staff_id") || dt[i].text == "!staff_id") {
            setEditable(false);
            dt[i].text = stafflist[K].staffid.toString();
          }
          if (dt[i].id == "avatar") {
            if (
              stafflist[kl].avatar != "" &&
              stafflist[kl].avatar.includes("https://")
            ) {
              console.log(stafflist[kl].avatar);

              // sessionStorage.removeItem('avatar');
              var replaceUrl = stafflist[kl].avatar.replace(
                "https://s3.amazonaws.com/topschool-attachments/",
                "https://files.prisms.in/"
              );

              console.log("REPLACE URL");
              console.log(replaceUrl);
              await toDataURL(replaceUrl, async function(dataUrl) {
                //  console.log('RESULT:', dataUrl)
                var fil = dataUrl.replace(
                  "application/octet-stream",
                  "image/png"
                );
                // let FileO = await dataURLtoFile(fil, Static_Data[K].name + '-Avater.png')
                // let file2 = await resizeFileC(FileO);
                var file2 = await resizedataURL(fil, 300, 300);
                dt[i].crossOrigin = "";
                dt[i].src = file2;
                var hasavatar = dt.filter((e) => e.id === "father");
                if (
                  hasavatar.length == 0 ||
                  stafflist[kl].mother_avatar == ""
                ) {
                  setTimeout(() => {
                    RenderImg2(JSON.stringify(dt));
                  }, 200);
                }

                // sessionStorage.setItem('avatar', file2)
                setTimeout(() => {
                  RenderImg(JSON.stringify(dt));
                }, 200);
              });
            } else {
              dt[i].src = "";
              dt[i].crossOrigin = "";
            }
          }

          if (dt[i].text == toupper("!dob") || dt[i].text == "!dob") {
            setEditable(false);
            dt[i].text = convertDate(stafflist[kl].dob);
          }
          if (
            dt[i].text == toupper("!bloodgroup") ||
            dt[i].text == "!bloodgroup"
          ) {
            dt[i].text = toupper(stafflist[kl].bloodgroup);
          }
          if (
            dt[i].text == toupper("!designation") ||
            dt[i].text == "!designation"
          ) {
            dt[i].text = toupper(stafflist[kl].staff_type);
          }
          if (
            dt[i].text == toupper("!staffDesig") ||
            dt[i].text == "!staffDesig"
          ) {
            dt[i].text = toupper(stafflist[kl].staffDesig);
          }
          if (
            dt[i].text == toupper("!qualification") ||
            dt[i].text == "!qualification"
          ) {
            dt[i].text = toupper(stafflist[kl].qualification);
          }
          if (
            dt[i].text == toupper("!joining_date") ||
            dt[i].text == "!joining_date"
          ) {
            dt[i].text = toupper(
              moment(stafflist[kl].joining_date).format("DD-MM-YYYY")
            );
          }
          if (dt[i].text == toupper("!gender") || dt[i].text == "!gender") {
            dt[i].text = toupper(stafflist[kl].gender);
          }
          if (
            dt[i].text == toupper("!employee_id") ||
            dt[i].text == "!employee_id"
          ) {
            dt[i].text = toupper(stafflist[kl].employee_id);
          }
          if (dt[i].text == toupper("!address") || dt[i].text == "!address") {
            var oldfz = dt[i].fontSize;

            var fsize = oldfz;
            var tx = toupper(stafflist[kl].address);
            var areatxt = tx.length * dt[i].fontSize * dt[i].height;
            var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            while (areatxt > arear) {
              fsize = parseFloat(fsize) - 0.1;

              dt[i].fontSize = fsize;
              var areatxt = tx.length * fsize * dt[i].height;
              var arear = dt[i].width * (dt[i].scaleY * dt[i].height);
            }
            if (fsize * 2 > oldfz) {
              dt[i].fontSize = oldfz;
            } else {
              dt[i].fontSize = fsize * 2;
            }
            dt[i].height = dt[i].scaleY * dt[i].height;
            dt[i].width = dt[i].width * dt[i].scaleX;
            dt[i].scaleY = 1;
            dt[i].scaleX = 1;
            dt[i].text = convertStr(tx);
          }
          if (dt[i].text == toupper("!mobile") || dt[i].text == "!mobile") {
            dt[i].text = stafflist[kl].mobile.toString();
          }
          if (dt[i].text == toupper("!mobile2") || dt[i].text == "!mobile2") {
            dt[i].text = stafflist[kl].mobile2.toString();
          }
          if (dt[i].id === "qrcode") {
            let datastr = JSON.stringify([
              { staffid: stafflist[kl].staffid, name: stafflist[kl].name },
            ]);
            try {
              dt[i].src = await QRCode.toDataURL(datastr.toString());
            } catch (err) {
              console.error(err);
            }
          }
          if (dt[i].id == "barcode") {
            let txt = dt[i].textfield.toString();
        
            if (txt.includes("Userid")) {
              txt = txt.replace("Userid", stafflist[kl].staff_id);
            }
            if (txt.includes("Mobile Number")) {
              txt = txt.replace("Mobile Number", stafflist[kl].mobile);
            }
            if (txt.includes("Timestamp")) {
              txt = txt.replace("Timestamp", Date.now().toString());
            }
            var canvasbar = document.createElement("canvas");
            JsBarcode(canvasbar, txt, { format: "CODE128" });
            try {
              dt[i].src = canvasbar.toDataURL("image/png");
            } catch (err) {
              console.error(err);
            }
          }
        }

        let hasavatar = dt.filter((e) => e.id === "avatar");

        if (hasavatar.length > 0) {
          if (hasavatar[0].src === undefined || hasavatar[0].src == "") {
            setTimeout(() => {
              RenderImg2(JSON.stringify(dt));
            }, 200);
          }
        }
        if (hasavatar.length === 0) {
          setTimeout(() => {
            RenderImg2(JSON.stringify(dt));
          }, 200);
        }
      }
    }
  };

  const RenderImg2 = (json) => {
    return new Promise((resolve, reject) => {
      try {
        refInput.current.handler.clear();

        refInput.current.handler.importJSON(json, () => {
          // Wait for a short delay to ensure rendering
          setTimeout(() => {
            refInput.current.canvas.renderAll();

            // Get base64 image and do something with it
            const dataURL = refInput.current.canvas.toDataURL();
            OpenImg(dataURL);

            resolve(); // Resolve after rendering and OpenImg call
          }, 200);
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  useEffect(() => {
    if (kl > 0) Setforclass();
  }, [kl]);

  const OpenImg = async (B6) => {
    if (B6 != null) {
      const fm = new FormData();
      if (Static_Data != null && Arrayd.usertype === "Student") {
        fm.append("userid", Static_Data[kl].userid);
        fm.append("sid", sid);
        fm.append("fun_name", "IDCard_Insert");
        fm.append("Usertype", "Student");
        fm.append("name", Static_Data[kl].name);
        let FileO = dataURLtoFile(B6, Static_Data[kl].name + "-IDCard.png");
        fm.append("designid", Arrayd.design_id);
        setA4([...A4, refInput.current.canvas.toDataURL()]);
        fm.append("file", FileO);
        fm.append("calssname", Static_Data[kl].class_name);
        fm.append("divname", Static_Data[kl].divname);
      }
      if (stafflist != null && Arrayd.usertype == "staff") {
        fm.append("staffid", stafflist[kl].staffid);
        fm.append("sid", sid);
        fm.append("fun_name", "IDCard_Insert");
        fm.append("Usertype", "staff");
        fm.append("name", stafflist[kl].name);
        let FileO = await dataURLtoFile(B6, stafflist[kl].name + "-IDCard.png");
        fm.append("designid", Arrayd.design_id);
        await setA4([...A4, refInput.current.canvas.toDataURL()]);
        fm.append("file", FileO);
      }
      await axios.post(configUrl, fm).then((res) => {
        console.log(res.data);
        setLoader(false);
      });

      if (Parent_Data != null && Arrayd.usertype === "Parent") {
        let bucketName = `topschool-attachments/${schoolName}prisms/idcardcanvas/parent/${
          Parent_Data[kl].name
        }}`;
        let formData = new FormData();
        formData.append("sid", DecryptED(sid));
        formData.append("userid", Parent_Data[kl].userid);
        formData.append("design_id", Arrayd.design_id);
        formData.append("bucketName", bucketName);
        let FileO = dataURLtoFile(B6, Parent_Data[kl].name + "-IDCard.png");
        setA4([...A4, refInput.current.canvas.toDataURL()]);

        formData.append("image", FileO);

        await axios({
          method: "POST",
          url: `${configUrl2}/api/idcard/insertDesign`,
          data: formData,
          headers: {
            Authorization: token,
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        }).then((res) => {
          setLoader(false);
        });
      }
      if (kl < total - 1) {
        setKL(kl + 1);
      } else if (kl === total - 1) {
        setLoaderAll(false);
        Swal.fire("Success", "ID card generated", "success");
      }
    }
  };
  const rotateBase64Image90deg = async (base64Image, isClockwise) => {
    // create an off-screen canvas
    var offScreenCanvas = document.createElement("canvas");
    var offScreenCanvasCtx = offScreenCanvas.getContext("2d");

    // cteate Image
    var img = new Image();
    img.src = base64Image;
    await delay(200);
    // set its dimension to rotated size
    offScreenCanvas.height = img.width;
    offScreenCanvas.width = img.height;

    if (isClockwise) {
      offScreenCanvasCtx.rotate((90 * Math.PI) / 180);
      offScreenCanvasCtx.translate(0, -offScreenCanvas.width);
    } else {
      offScreenCanvasCtx.rotate((-90 * Math.PI) / 180);
      offScreenCanvasCtx.translate(-offScreenCanvas.height, 0);
    }
    offScreenCanvasCtx.drawImage(img, 0, 0);
    return Promise.resolve(offScreenCanvas.toDataURL("image/jpeg", 200));
  };
  const Print = async () => {
    if (A4.length === 0) {
      Swal.fire("Info", "First apply to all div befour print", "info");
    } else {
      setRotate(true);
      var A4Rotate = [];
      if (Canvastype === 1) {
        for (let i = 0; i < A4.length; i++) {
          let tmp = await rotateBase64Image90deg(A4[i], false);
          A4Rotate.push(tmp);
        }
      } else {
        A4Rotate = A4;
      }

      setTimeout(() => {
        setRotate(false);

        history.push("/idcardCanvas/PrintView/" + sid, { data2: A4Rotate });
      }, 1500);
    }
  };

  const DownloadLoop = () => {
    if (A4.length === 0) {
      Swal.fire("Info", "First apply to all div before downloading", "info");
    } else {
      const zip = new JSZip();
      const imagePromises = [];

      for (let i = 0; i < A4.length; i++) {
        const imageUrl = A4[i];
        const imagePromise = fetch(imageUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const filename = `Image-${i}.png`;
            zip.file(filename, blob);
          })
          .catch((error) => {
            console.error(`Error fetching image: ${imageUrl}`, error);
          });

        imagePromises.push(imagePromise);
      }

      Promise.all(imagePromises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then((content) => {
            saveAs(content, "images.zip");
          });
        })
        .catch((error) => {
          console.error("Error fetching images:", error);
        });
    }
  };

  const SetDefault = () => {
    if (isDefault) {
      Swal.fire("info", "Design is already set as default", "info");
    } else {
      var c = window.confirm(
        'Do you want to set "' +
          Arrayd.design_name +
          '" as default idcard design for ' +
          Arrayd.usertype
      );
      if (c) {
        axios
          .post(configUrl, {
            fun_name: "DefaultIDCard",
            sid: sid,
            dname: Arrayd.design_name,
            design_id: Arrayd.design_id,
            usertype: Arrayd.usertype,
          })
          .then((res) => {
            window.alert("Successfully Updated the design");
            setIsDefault(true);
          });
      }
    }
  };
  const Tutotial = () => {
    setTutorial(true);
  };
  const HideTutorial = () => {
    setTutorial(false);
  };
  const Generate = () => {
    setSearch(true);
  };
  const HideGenerate = () => {
    setSearch(false);
  };
  const drawer = (
    <div>
      <List style={{ height: "95vh" }}>
        <ListItem button onClick={() => setLoadDesign()}>
          <ListItemIcon>
            <CachedIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"Open Design"} />
        </ListItem>

        <ListItem button onClick={() => setCtype(1)}>
          <ListItemIcon>
            <PanoramaVerticalIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"Vertical Canvas"} />
        </ListItem>

        <ListItem button onClick={() => setCtype(0)}>
          <ListItemIcon>
            <PanoramaHorizontalIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"Horizontal Canvas"} />
        </ListItem>
        <ListItem
          button
          className={classes.nested}
          onClick={() => setOpenSh(!openShapes)}
        >
          <ListItemIcon>
            <AllOutIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Shapes" />
          {openShapes ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openShapes} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            style={{ marginLeft: openD ? 20 : 0 }}
          >
            <ListItem button onClick={() => Line()}>
              <ListItemIcon>
                <RemoveIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={"Line"} />
            </ListItem>
            <ListItem button onClick={() => Cir()}>
              <ListItemIcon>
                <RadioButtonUncheckedIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={"Circle"} />
            </ListItem>
            <ListItem button onClick={() => Tri()}>
              <ListItemIcon>
                <ChangeHistoryIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={"Triangle"} />
            </ListItem>
            <ListItem button onClick={() => Rect()}>
              <ListItemIcon>
                <CheckBoxOutlineBlankIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={"Square"} />
            </ListItem>
            <ListItem button>
              <div style={{ display: "flex" }}>
                <Typography>Select Color : </Typography>
                <input
                  type="color"
                  style={{ background: color != null ? color : "#000000" }}
                  onChange={(e) => setColor(e.target.value)}
                />
              </div>
            </ListItem>
          </List>
        </Collapse>

        <ListItem
          button
          onClick={() => {
            setOpen(!open);
          }}
        >
          <ListItemIcon>
            <TextFieldsIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"Text"} />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            style={{ marginLeft: openD ? 20 : 0 }}
          >
            <ListItem
              button
              className={classes.nested}
              onClick={() => Textbtn()}
            >
              <ListItemIcon>
                <LabelIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary="Label" />
            </ListItem>

            <ListItem
              button
              className={classes.nested}
              onClick={() => setFAlias(!falias)}
            >
              <ListItemIcon>
                <PostAddRoundedIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={
            
                  Arrayd != null &&
                  (Arrayd.usertype === "Student"
                    ? "Student Information"
                    : Arrayd.usertype === "staff"
                    ? "Staff Information"
                    : "Parent Information")
                }
              />
              {falias ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={falias} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  style={{ textAlign: "left" }}
                  button
                  className={classes.nested}
                  onClick={() => FAlias("!name")}
                >
                  <TextField
                    size="medium"
                    // style={{b}}
                    variant="outlined"
                    fullWidth
                    id="pmob"
                    label="Search"
                    value={se}
                    onChange={(e) => setFind(e.target.value)}
                    InputProps={{
                      className: classes.input,
                    }}
                  />
                </ListItem>
                {/* Getting field_name dynamically from DataBase */}
                {Arrayd != undefined
                  ? Arrayd.field_name_display.split(",").map((v, u) =>
                      v.toLowerCase().includes(se.toLowerCase()) && se != "" ? (
                        <ListItem
                          style={{ textAlign: "left", fontWeight: "bold" }}
                          button
                          className={classes.nested}
                          onClick={() => FAlias(capitalize(v))}
                        >
                          <ListItemText primary={capitalize(v)} />
                        </ListItem>
                      ) : se === "" ? (
                        <ListItem
                          style={{ textAlign: "left" }}
                          button
                          className={classes.nested}
                          onClick={() => FAlias(capitalize(v))}
                        >
                          <ListItemText primary={capitalize(v)} />
                        </ListItem>
                      ) : null
                    )
                  : null}
              </List>
            </Collapse>
            {/* <Divider/> */}
          </List>
        </Collapse>
        <ListItem
          button
          className={classes.nested}
          onClick={() => setOpenTC(!openTextC)}
        >
          <ListItemIcon>
            <TextFormatIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Font Settings" />
          {openTextC ? <ExpandLess /> : <ExpandMore />}
        </ListItem>

        <Collapse in={openTextC} timeout="auto" unmountOnExit>
          <TextC
            fs={FontSize}
            fm={FontFamily}
            fb={FontB}
            al={FontAL}
            ac={FontAC}
            fntcolor={FontColor}
          />
        </Collapse>
        <ListItem button onClick={() => Qrcode()}>
          {/* <img src={imgurl} ref={refimg} style={{display:'none'}} /> */}
          <ListItemIcon>
            <CenterFocusStrongIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"QRcode"} />
        </ListItem>
        <ListItem button onClick={() => setTOpen(true)}>
          {/* <img src={imgurl} ref={refimg} style={{display:'none'}} /> */}
          <ListItemIcon>
            <FormatAlignJustifyIcon
              style={{ transform: "rotate(90deg)" }}
              color="primary"
            />
          </ListItemIcon>
          <ListItemText primary={"Barcode"} />
        </ListItem>
        <ListItem
          button
          className={classes.nested}
          onClick={() => setOpenPh(!openPhotos)}
        >
          <ListItemIcon>
            <PhotoCameraIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Photos" />
          {openPhotos ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openPhotos} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            style={{ marginLeft: openD ? 20 : 0 }}
          >
            <ListItem button onClick={() => handleChange()}>
              {/* <img src={imgurl} ref={refimg} style={{display:'none'}} /> */}
              <ListItemIcon>
                <FaceIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={
                  Arrayd != null &&
                  (Arrayd.usertype === "Student"
                    ? "Student Pic"
                    : Arrayd.usertype === "staff"
                    ? "Staff"
                    : "Student Pic")
                }
              />
            </ListItem>

        {process.env.NODE_ENV === "development" && (
  <ListItem button onClick={() => handleChangeRounded()}>
    <ListItemIcon>
      <FaceIcon color="primary" />
    </ListItemIcon>
    <ListItemText
      primary={
        Arrayd != null &&
        (Arrayd.usertype === "Student"
          ? "Rounded Student Pic"
          : Arrayd.usertype === "staff"
          ? "Rounded Staff Pic"
          : "Rounded Student Pic")
      }
    />
  </ListItem>
)}

            {Arrayd != null &&
            (Arrayd.usertype === "Student" || Arrayd.usertype === "Parent") ? (
              <>
                <ListItem button onClick={() => handleChangeF()}>
                  {/* <img src={imgurl} ref={refimg} style={{display:'none'}} /> */}
                  <ListItemIcon>
                    <PersonIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={"Father Pic"} />
                </ListItem>
                <ListItem button onClick={() => handleChangeM()}>
                  {/* <img src={imgurl} ref={refimg} style={{display:'none'}} /> */}
                  <ListItemIcon>
                    <PersonIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText primary={"Mother Pic"} />
                </ListItem>
                {Arrayd != null && Arrayd.usertype === "Parent" ? (
                  <ListItem button onClick={() => handleChangeG()}>
                    <ListItemIcon>
                      <PersonIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={"Guardian Pic"} />
                  </ListItem>
                ) : null}
              </>
            ) : null}
            <input
              accept="image/*"
              type="file"
              id="contained-button-file-logo"
              style={{ display: "none" }}
              onChange={(e) => handleLogo(e)}
            />

            <label htmlFor="contained-button-file-logo">
              <ListItem button>
                <ListItemIcon>
                  <ImageIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={"Image/Logo"} />
              </ListItem>
            </label>
          </List>
        </Collapse>

        {/* </label> */}
        <input
          accept="image/*"
          type="file"
          id="contained-button-file-back"
          style={{ display: "none" }}
          onChange={(e) => handleChangeBack(e)}
        />

        <label htmlFor="contained-button-file-back">
          <ListItem button>
            <img
              src={imgurl}
              ref={refimg}
              style={{ display: "none" }}
              alt={""}
            />
            <ListItemIcon>
              <ImageIcon color="primary" />
            </ListItemIcon>
            <ListItemText primary={"Upload Background Image"} />
          </ListItem>
        </label>
        <ListItem button onClick={() => Clear()}>
          <ListItemIcon>
            <ClearAllOutlinedIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary={"Clear"} />
        </ListItem>

        {Arrayd != null && Arrayd.usertype === "Student" ? (
          <ListItem>
            <ListItemIcon>
              <GetAppIcon color="primary" />
            </ListItemIcon>
            <Link
              style={{ color: "black" }}
              target="_blank"
              to={{
                pathname:
                  "/IdcardCanvas/download/idcards/" + sid + "/" + idesign,
              }}
            >
              <ListItemText primary={"Download Idcards"} />
            </Link>
          </ListItem>
        ) : null}
          {Arrayd != null && Arrayd.usertype === "Parent" ? (
          <ListItem>
            <ListItemIcon>
              <GetAppIcon color="primary" />
            </ListItemIcon>
            <Link
              style={{ color: "black" }}
              target="_blank"
              to={{
                pathname:
                  "/IdcardCanvas/download/parent/idcards/" + sid + "/" + idesign,
              }}
            >
              <ListItemText primary={"Download Idcards"} />
            </Link>
          </ListItem>
        ) : null}

        {Arrayd != null && Arrayd.usertype === "staff" ? (
          <ListItem>
            <ListItemIcon>
              <GetAppIcon color="primary" />
            </ListItemIcon>
            <Link
              style={{ color: "black" }}
              target="_blank"
              to={{
                pathname:
                  "/IdcardCanvas/download/staff/idcards/" + sid + "/" + idesign,
              }}
            >
              <ListItemText primary={"Download Staff Idcards"} />
            </Link>
          </ListItem>
        ) : null}
      </List>
    </div>
  );

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openD,
        })}
      >
        <Toolbar variant="dense">
          <IconButton
            style={{ border: "none", outline: "none" }}
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: openD,
            })}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            ID Card Design
          </Typography>

          {Canvastype === 0 && Arrayd != null && Arrayd !== "" ? (
            <div>
              <p
                style={{ fontSize: 18, marginLeft: "27vw", display: "inline" }}
              >
                {" "}
                Current Design : {Arrayd.design_name}{" "}
              </p>
              {Static_Data != null ||
              stafflist != null ||
              Parent_Data != null ? (
                UserID != null ? (
                  <p
                    style={{
                      fontSize: 18,
                      display: "inline",
                      marginLeft: "13vw",
                    }}
                  >
                    {Arrayd.usertype === "Student"
                      ? "Student Information"
                      : Arrayd.usertype === "staff"
                      ? "Staff Information"
                      : "Parent Information"}
                    {/* {Arrayd.usertype == "Student" ? "Userid : " : "StaffID : "} */}
                    {UserID}
                  </p>
                ) : null
              ) : null}
            </div>
          ) : null}
        </Toolbar>
      </AppBar>
      <Drawer
        // container={container}
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: openD,
          [classes.drawerClose]: !openD,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: openD,
            [classes.drawerClose]: !openD,
          }),
        }}
      >
        <div className={classes.toolbar} style={{ minHeight: 46 }}>
          <IconButton
            style={{ border: "none", outline: "none" }}
            onClick={handleDrawerClose}
          >
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        {drawer}
      </Drawer>

      <main className={classes.content}>
        {mainModel ? (
          <ModelTop
            close={handleLoadClose}
            ld={LoadDesign}
            opendes={OpenDesign}
          />
        ) : null}
        {SText ? (
          <Barcode1
            open={SText}
            close={handlebarcodeClose}
            gen={handlebarcode}
          />
        ) : null}
        {isTutorial ? (
          <Tutorials open={isTutorial} close={HideTutorial} />
        ) : null}
        {isSearch && Arrayd != null ? (
          <Search
            open={isSearch}
            close={HideGenerate}
            usertype={Arrayd.usertype}
            s={
              Arrayd.usertype === "Student"
                ? "Student Information"
                : Arrayd.usertype === "staff"
                ? "Staff Information"
                : "Parent Information"
            }
            // s={Arrayd.usertype === "Student" ? "Student" : "Staff"}
            did={Arrayd.design_id}
          />
        ) : null}
        <FormControlLabel
          style={{
            position: Canvastype === 1 ? "absolute" : "absolute",
            left: Canvastype === 1 ? 610 : 1017,
            top: Canvastype === 1 ? 128 : 91,
            marginRight: 20,
          }}
          control={
            <Checkbox
              checked={isDefault}
              onChange={() => SetDefault()}
              name="checkedB"
              color="primary"
            />
          }
          label="default design"
        />
        <div className={classes.toolbar} />

        {Canvastype === 0 ? (
          <Canvasfd left={"30vw"} editable={editable} ref={refInput} />
        ) : null}

        {Canvastype === 1 ? (
          <CanvasV ref={refInput} editable={editable} />
        ) : null}
        {progress ? (
          <div style={{ position: "fixed", top: "40vh", left: "50vw" }}>
            <CircularProgress style={{ marginRight: 30, marginLeft: 30 }} />
          </div>
        ) : null}

        <div
          style={{
            position: "absolute",
            display: "flex",
            top: Canvastype === 1 ? 150 : 472,
            left: Canvastype === 1 ? 860 : "auto",
            width: Canvastype === 1 ? 475 : 1024,
          }}
        >
          <BootstrapTooltip
            title="Edit Design"
            nm="Edit"
            placement={Canvastype === 1 ? "bottom" : "right"}
            ctype={Canvastype}
          >
            <div>
              <IconButton
                size="medium"
                style={{
                  border: "1px solid",
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -478 : 8,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
                onClick={() => EditDes()}
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <EditIcon fontSize="large" color="primary" />
              </IconButton>
            </div>
          </BootstrapTooltip>

          <BootstrapTooltip
            title="Save Design"
            placement={Canvastype == 1 ? "bottom" : "right"}
            nm="Save"
            ctype={Canvastype}
          >
            <div>
              <IconButton
                disabled={iseditclick && CurrDesign != "" ? false : true}
                style={{
                  border: "1px solid",
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -36 : 368,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
                size="medium"
                onClick={() => SaveDesign()}
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <SaveIcon fontSize="large" color="primary" />
              </IconButton>{" "}
            </div>
          </BootstrapTooltip>

          {/* <BootstrapTooltip
            title="Download Image"
            nm="Down"
            placement={Canvastype === 1 ? "bottom" : "right"}
            ctype={Canvastype}
          >
            <div>
              <IconButton
                style={{
                  border: "1px solid",
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -256 : 248,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
                size="medium"
                onClick={() => SaveAsImage()}
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <GetAppIcon fontSize="large" color="primary" />
              </IconButton>
            </div>
          </BootstrapTooltip> */}
          <BootstrapTooltip
            title="Download Image"
            nm="Down"
            placement={Canvastype === 1 ? "bottom" : "right"}
            ctype={Canvastype}
          >
            <div>
              <IconButton
                style={{
                  border: "1px solid",
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -256 : 248,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
                size="medium"
                onClick={handleMenuClick}
                variant="contained"
                color="primary"
              >
                <GetAppIcon fontSize="large" color="primary" />
              </IconButton>
            </div>
          </BootstrapTooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
         { highResolution !== "1" &&   <MenuItem onClick={() => handleMenuItemClick("currentDesign")}>
              High resoultion Design
            </MenuItem> }

        
            <MenuItem onClick={() => handleMenuItemClick("oldDesign")}>
            { highResolution === "0" ? "Low resoultion Design" : "Download Design" } 
            </MenuItem>
          </Menu>

          <BootstrapTooltip
            title="Print Design"
            nm="Print"
            placement={Canvastype === 1 ? "bottom" : "right"}
            ctype={Canvastype}
          >
            {isRotate ? (
              <div
                style={{
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -369 : 128,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
              >
                <CircularProgress style={{ marginRight: 30, marginLeft: 30 }} />
              </div>
            ) : (
              <div>
         { highResolution !== "1" &&          <IconButton
                  style={{
                    border: "1px solid",
                    position: Canvastype === 1 ? "absolute" : "absolute",
                    left: Canvastype === 1 ? -369 : 128,
                    top: Canvastype === 1 ? -97 : -410,
                    marginRight: 20,
                  }}
                  onClick={() => Print()}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  <PrintIcon color="primary" fontSize="large" />
                </IconButton> }
              </div>
            )}
          </BootstrapTooltip>
          <BootstrapTooltip
            title="Tutorial"
            nm="Tutorial"
            placement={Canvastype == 1 ? "bottom" : "right"}
            ctype={Canvastype}
          >
            <div>
              <IconButton
                style={{
                  border: "1px solid",
                  position: Canvastype === 1 ? "absolute" : "absolute",
                  left: Canvastype === 1 ? -142 : 608,
                  top: Canvastype === 1 ? -97 : -410,
                  marginRight: 20,
                }}
                onClick={() => Tutotial()}
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <HelpIcon color="primary" fontSize="large" />
              </IconButton>
            </div>
          </BootstrapTooltip>

    { highResolution !== "1" &&         Arrayd != null ? (
            <BootstrapTooltip
              title={
                // Arrayd.usertype === "Student"
                //   ? "Student Specific ID"
                //   : "Staff Specific ID"
                Arrayd.usertype === "Student"
                  ? "Student Information"
                  : Arrayd.usertype === "staff"
                  ? "Staff Information"
                  : "Parent Information"
              }
              nm="Student Specific"
              placement={Canvastype == 1 ? "bottom" : "right"}
              ctype={Canvastype}
            >
              <div>
                <IconButton
                  style={{
                    border: "1px solid",
                    position: Canvastype === 1 ? "absolute" : "absolute",
                    left: Canvastype === 1 ? 70 : 488,
                    top: Canvastype === 1 ? -97 : -410,
                    marginRight: 20,
                  }}
                  onClick={() => Generate()}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  <FeaturedPlayList color="primary" fontSize="large" />
                </IconButton>
              </div>
            </BootstrapTooltip>
          ) : null} 

          <div
            style={{
              display: Canvastype === 1 ? "block" : "flex",
              marginTop: 20,
            }}
          >
            <div
              style={{
                position: "absolute",
                top: Canvastype === 1 ? 80 : 85,
                left:
                  Canvastype === 1
                    ? 13
                    : // eslint-disable-next-line no-mixed-operators
                    (Arrayd !== null &&
                        (Arrayd.usertype === "Student" ||
                          Arrayd.usertype === "Parent")) ||
                      Arrayd
                    ? "auto"
                    : 50,
              }}
            >
              {/* SELECT CLASS FOR PARENT OR STUDENT ID CARD */}
              {Arrayd != null && Arrayd.usertype === "Parent" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{
                    marginBottom: Canvastype === 1 ? 1 : 30,
                    marginRight: 12,
                    marginTop: Canvastype === 1 ? 40 : 10,
                    width: Canvastype === 1 ? 158 : 200,
                  }}
                >
                  <InputLabel id="div">Select Class </InputLabel>
                  <Select
                    variant="outlined"
                    style={{ borderRadius: 54 }}
                    labelId="class"
                    id="class"
                    // onChange={handleChangeClass}
                    value={Sclass}
                    onChange={(event) => setClass(event.target.value)}
                    label="Select Class"
                  >
                    {classnm !== undefined && Arrayd != null
                      ? Arrayd.class.split(",").map((v, i) =>
                          Object.keys(classdivmap).includes(v) ? (
                            // JSON.parse(sessionStorage.getItem('design-current')).classname.includes(v.class_name)?
                            <MenuItem value={classdivmap[v][0].class}>
                              {classdivmap[v][0].class_name}
                            </MenuItem>
                          ) : null
                        )
                      : null}
                  </Select>
                </FormControl>
              ) : null}

              {/* Multiple select Div and classnm for Student */}

              {Arrayd != null && Arrayd.usertype === "Student" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{
                    marginBottom: Canvastype === 1 ? 1 : 30,
                    marginRight: 12,
                    marginTop: Canvastype === 1 ? 40 : 10,
                    width: Canvastype === 1 ? 158 : 200,
                  }}
                >
                  {" "}
                  <RSelect
                    className="st"
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    onChange={(selectedOptions) => {
                      const selectedIds = selectedOptions.map(
                        (option) => option.value
                      );
                      setClassDiv((prevState) => ({
                        ...prevState,
                        SclassId: selectedIds,
                      }));
                    }}
                    placeholder="Select Class"
                    isMulti
                    options={classDiv.SclassName.map((data, index) => ({
                      value: data.id,
                      label: data.class_name,
                    }))}
                  />
                </FormControl>
              ) : null}

              {Arrayd != null && Arrayd.usertype === "Student" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{
                    marginBottom: Canvastype === 1 ? 1 : 30,
                    marginRight: 12,
                    marginTop: Canvastype === 1 ? 40 : 10,
                    width: Canvastype === 1 ? 158 : 200,
                  }}
                >
                  <RSelect
                    className="st"
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    onChange={(selectedOptions) => {
                      const selectedIds = selectedOptions.map(
                        (option) => option.value
                      );
                      setClassDiv((prevState) => ({
                        ...prevState,
                        SdivId: selectedIds,
                      }));
                    }}
                    placeholder="Select Div"
                    isMulti
                    options={
                      Array.isArray(classDiv.SDivisionName)
                        ? classDiv.SDivisionName.map((data, index) => ({
                            value: data.id,
                            label: data.div_name,
                          }))
                        : []
                    }
                  />
                </FormControl>
              ) : null}

              {/*  */}
              {/* STAFF TYPE */}

              {Arrayd != null && Arrayd.usertype === "staff" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  fullWidth
                  style={{
                    marginBottom: 30,
                    marginRight: 12,
                    marginTop: Canvastype === 1 ? 40 : 10,
                    width: Canvastype === 1 ? 400 : 400,
                  }}
                >
                  <RSelect
                    // className="st"
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    onChange={(selectedOptions) => {
                      const selectedIds = selectedOptions.map(
                        (option) => option.label
                      );
                      setStaff(selectedIds);
                    }}
                    placeholder="Select Staff"
                    isMulti
                    options={
                      Array.isArray(Stafftype)
                        ? Stafftype.map((data, index) => ({
                            value: index,
                            label: data,
                          }))
                        : "Data is Not available"
                    }
                  />
                </FormControl>
              ) : null}

              {/* SELECT DIVISION FOR PARENT OR STUDENT ID CARD  */}
              {Arrayd != null && Arrayd.usertype === "Parent" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{
                    marginBottom: Canvastype === 1 ? 1 : 30,
                    marginRight: 12,
                    marginTop: Canvastype === 1 ? 40 : 10,
                    width: Canvastype === 1 ? 158 : 200,
                  }}
                >
                  <InputLabel id="div">Select Div </InputLabel>
                  <Select
                    fullWidth
                    style={{ borderRadius: 54 }}
                    labelId="div"
                    id="div"
                    value={Sdiv !== undefined ? Sdiv : ""}
                    // onChange={handleChangeDiv}
                    onChange={(event) => setDiv(event.target.value)}
                    label="Select Div"
                  >
                    {classdivmap !== undefined && Sclass != null
                      ? classdivmap[Sclass].map((v, i) => (
                          <MenuItem value={v.divid}>{v.div_name}</MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              ) : null}
              {/* PREVIEW FOR STUDENT ID CARD */}
              {/* PREVIEW FOR Parent ID  */}
              {Arrayd != null &&
              (Arrayd.usertype === "Student" ||
                Arrayd.usertype === "Parent") ? (
                <Button
                  style={{
                    borderRadius: 54,
                    border: "none",
                    outline: "none",
                    marginRight: 3,
                    marginLeft: Canvastype === 1 ? 20 : 10,
                    height: "fit-content",
                    marginTop: Canvastype === 1 ? 40 : 10,
                  }}
                  onClick={() => {
                    setK(0);
                    handleTotal();
                    getList1(Sclass, Sdiv);
                  }}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  {Arrayd.usertype === "Student"
                    ? "Preview"
                    : "Preview ParentID"}
                </Button>
              ) : null}

              {/* PREVIEW STAFF ID */}
              {Arrayd != null && Arrayd.usertype === "staff" ? (
                <Button
                  style={{
                    borderRadius: 54,
                    border: "none",
                    outline: "none",
                    marginLeft: Canvastype === 1 ? 50 : 10,
                    height: "fit-content",
                    marginTop: Canvastype === 1 ? 40 : 10,
                  }}
                  onClick={() => {
                    setK(0);
                    handleTotal();
                    getstafflist();
                  }}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  Preview Staff ID
                </Button>
              ) : null}

              {/* PREVIEW STUDENT ID */}
              {Arrayd != null &&
              (Arrayd.usertype === "Student" ||
                Arrayd.usertype === "staff" ||
                Arrayd.usertype === "Parent") ? (
                <Button
                  style={{
                    display: Canvastype === 1 ? "flex" : "initial",
                    borderRadius: 54,
                    border: "none",
                    outline: "none",
                    marginLeft: Canvastype === 1 ? 140 : 10,
                    height: "fit-content",
                    marginTop: Canvastype === 1 ? 32 : 10,
                  }}
                  onClick={() => Setforclass("student")}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  {Arrayd.usertype === "Student"
                    ? "Apply"
                    : Arrayd.usertype === "Parent"
                    ? "Apply ParentID"
                    : "Apply StaffID"}
                </Button>
              ) : null}

              {/* DOWNLOAD ALL ID CARDS */}
              {A4.length > 0 ? (
                <Button
                  style={{
                    display: Canvastype === 1 ? "flex" : "initial",
                    left: Canvastype === 1 ? 80 : 10,
                    borderRadius: 54,
                    border: "none",
                    outline: "none",
                    marginRight: 3,
                    height: "fit-content",
                    marginTop: Canvastype === 1 ? 26 : 10,
                  }}
                  onClick={() => DownloadLoop()}
                  variant="contained"
                  color="primary"
                  // className={classes.submit}
                >
                  Download All
                </Button>
              ) : null}
              {Static_Data != null ? (
                UserID != null ? (
                  <Button
                    style={{
                      display: Canvastype === 1 ? "flex" : "initial",
                      borderRadius: 54,
                      border: "none",
                      outline: "none",
                      marginRight: 3,
                      marginLeft: Canvastype === 200 ? 0 : "3vw",
                      height: "fit-content",
                      marginTop: Canvastype === 1 ? 26 : 10,
                    }}
                    onClick={() => Largest()}
                    variant="contained"
                    color="primary"
                    // className={classes.submit}
                  >
                    Preview Largest Address
                  </Button>
                ) : null
              ) : null}

              {/* PREVIEW LARGET ADDRESS FOR PARENT ID CARD */}
              {Parent_Data != null ? (
                UserID != null ? (
                  <Button
                    style={{
                      display: Canvastype === 1 ? "flex" : "initial",
                      borderRadius: 54,
                      border: "none",
                      outline: "none",
                      marginRight: 3,
                      marginLeft: Canvastype === 200 ? 0 : "3vw",
                      height: "fit-content",
                      marginTop: Canvastype === 1 ? 26 : 10,
                    }}
                    onClick={() => Largest2()}
                    variant="contained"
                    color="primary"
                    // className={classes.submit}
                  >
                    Preview Largest Address
                  </Button>
                ) : null
              ) : null}

              {iseditclick ? (
                CurrDesign != "" ? (
                  <Button
                    style={{
                      display: Canvastype === 1 ? "flex" : "initial",
                      left: Canvastype === 1 ? 60 : 10,
                      borderRadius: 54,
                      border: "none",
                      outline: "none",
                      marginRight: 3,
                      height: "fit-content",
                      marginTop: Canvastype === 1 ? 26 : 10,
                    }}
                    onClick={() => setLock(!islock)}
                    variant="contained"
                    color="primary"
                    // className={classes.submit}
                  >
                    {islock !== true ? "Lock" : "Unlock"} Background Image
                  </Button>
                ) : null
              ) : null}
            </div>

            {loaderM ? (
              <div style={{ position: "relative", display: "flex" }}>
                <CircularProgress style={{ marginRight: 30, marginLeft: 30 }} />
              </div>
            ) : null}
            {loader ? <CircularProgress /> : null}
            {Saved ? (
              <Savedesign
                close={handleSaveClose}
                clear={Clear}
                ld={LoadDesign}
                Ori={Canvastype}
              />
            ) : null}
            {loadD ? (
              <Loaddesign close={handleLoadClose} ld={LoadDesign} />
            ) : null}
            {finald ? (
              <SetFinalDesign
                close={handleFinalClose}
                ld={LoadDesign}
                Ori={Canvastype}
              />
            ) : null}
          </div>

          {iseditclick == false ? (
            <>
              {" "}
              <IconButton
                style={{
                  position: "absolute",
                  top: Canvastype === 1 ? 92 : -243,
                  left: Canvastype === 1 ? -565 : 0,
                }}
                onClick={() => handlePrev()}
                fullWidth
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <ArrowBackIosIcon
                  color="primary"
                  style={{ width: 80, height: 80 }}
                />
              </IconButton>
              <IconButton
                style={{
                  position: "absolute",
                  top: Canvastype === 1 ? 92 : -243,
                  left: Canvastype === 1 ? -60 : 720,
                }}
                onClick={() => handleNext()}
                fullWidth
                variant="contained"
                color="primary"
                // className={classes.submit}
              >
                <ArrowForwardIosIcon
                  color="primary"
                  style={{ width: 80, height: 80 }}
                />
              </IconButton>
            </>
          ) : null}
          {loaderAll ? <CircularProgress /> : null}
        </div>
      </main>
    </div>
  );
}

export default ContainerMain;
